import { storeToRefs as J, defineStore as kn, createPinia as so } from "pinia";
import { defineComponent as En, shallowRef as $e, onMounted as Re, computed as ge, watch as be, createElementBlock as g, openBlock as v, normalizeStyle as qe, normalizeClass as _e, createElementVNode as a, mergeProps as ao, renderSlot as Tn, Fragment as oe, renderList as Fe, createVNode as Z, reactive as io, watchEffect as ro, onUnmounted as Ye, useCssVars as lo, unref as d, withDirectives as W, createCommentVNode as Y, withModifiers as at, setBlockTracking as cn, vShow as un, ref as Q, getCurrentInstance as It, createStaticVNode as co, createBlock as le, Teleport as uo, Transition as Ot, withCtx as ce, toDisplayString as A, render as dn, resolveDirective as ve, createTextVNode as G, mergeModels as Ut, useModel as Pn, vModelText as fo, onActivated as po, KeepAlive as mo, resolveDynamicComponent as vo, nextTick as fn, defineCustomElement as ho } from "vue";
import { promiseStatesHook as Rn, Method as Ln, setCache as Mt, globalConfigMap as go, queryCache as At, invalidateCache as _o, createAlova as yo } from "alova";
import bo from "dayjs";
const zt = "undefined", it = Promise, In = (e) => it.resolve(e), wo = (e) => it.reject(e), Ge = Object, L = void 0, Co = null, U = !0, O = !1, Yt = (e, t, n) => e.then(t, n), dt = (e, t) => e.catch(t), ft = (e, t) => e.finally(t), xo = (e) => it.all(e), $o = (e, t, n) => JSON.stringify(e, t, n), Qe = (e, t = 0) => setTimeout(e, t), Ft = (e) => clearTimeout(e), Mn = (e) => Ge.keys(e), zn = (e) => Ge.values(e), Be = (e, t) => e.forEach(t), Ke = (e, ...t) => e.push(...t), De = (e, t) => e.map(t), pt = (e, t) => e.filter(t), So = (e) => e.shift(), We = (e, t, n = 0, ...s) => e.splice(t, n, ...s), re = (e) => e.length, mt = (e) => Array.isArray(e), Bt = (e, t) => delete e[t], Kt = (e) => typeof e, ot = (e, t) => e.includes(t);
typeof window === zt && (typeof process !== zt && process.cwd);
const Vt = "memory", ko = "restore", Se = () => {
}, Eo = (e) => e, me = (e) => Kt(e) === "function", we = (e) => Kt(e) === "number" && !Number.isNaN(e), To = (e) => Kt(e) === "string", Dn = (e) => Ge.prototype.toString.call(e), Po = (e) => Dn(e) === "[object Object]", Oe = (e, t) => e instanceof t, vt = (e) => e ? e.getTime() : Date.now(), Nn = (e) => e.context, Ro = (e) => e.config, Ue = (e) => e.key, On = (e, t, n = []) => {
  const s = me(e) ? e(...n) : e;
  return t(!!s.key, "hook handler must be a method instance or a function that returns method instance"), s;
}, Lo = (e) => {
  const t = Dn(e);
  return /^\[object (Blob|FormData|ReadableStream|URLSearchParams)\]$/i.test(t) || Oe(e, ArrayBuffer);
}, bt = (e, ...t) => Ge.assign(e, ...t), Io = (e, ...t) => {
  const n = {};
  for (const s in e)
    t.includes(s) || (n[s] = e[s]);
  return n;
};
function Un() {
  let e, t;
  return { promise: new Promise((s, o) => {
    e = s, t = o;
  }), resolve: e, reject: t };
}
const Mo = (e) => {
  const { cacheFor: t } = Ro(e), n = (m) => we(m) ? vt() + m : vt(m || L);
  let s = Vt, o = () => 0, l = O, u = L;
  const f = me(t);
  if (!f) {
    let m = t;
    if (Po(t)) {
      const { mode: r = Vt, expire: i, tag: c } = t || {};
      s = r, l = r === ko, u = c ? c.toString() : L, m = i;
    }
    o = (r) => n(me(m) ? m({ method: e, mode: r }) : m);
  }
  return {
    f: t,
    c: f,
    e: o,
    m: s,
    s: l,
    t: u
  };
}, pe = (e, ...t) => new e(...t), An = (e, t = []) => me(e) ? e(...t) : e, zo = (e = 0) => {
  let t = L;
  return (n) => {
    t && clearTimeout(t), t = Qe(n, e);
  };
}, Do = (e = O) => {
  const t = [];
  let n = L, s = !1;
  const o = async () => {
    for (s = U; re(t) > 0; ) {
      const f = So(t);
      f && await f();
    }
    n && n(), s = O;
  };
  return {
    addQueue: (f) => pe(it, (m, r) => {
      Ke(t, () => Yt(f(), m, (c) => {
        e ? m(L) : r(c);
      })), s || o();
    }),
    onComplete: (f) => {
      n = f;
    }
  };
}, No = "$a.", Oo = (e, t) => No + e + t;
class Uo extends Error {
  constructor(t, n, s) {
    super(n + (s ? `

For detailed: https://alova.js.org/error#${s}` : "")), this.name = `[alova${t ? `/${t}` : ""}]`;
  }
}
const wt = (e = "") => (t, n, s) => {
  if (!t)
    throw pe(Uo, e, n, s);
}, Ao = JSON.parse, Fo = () => Ao.bridgeData || {}, Vo = () => {
  const e = {};
  return {
    eventMap: e,
    on(t, n) {
      const s = e[t] = e[t] || [];
      return Ke(s, n), () => {
        e[t] = pt(s, (o) => o !== n);
      };
    },
    off(t, n) {
      const s = e[t];
      if (s)
        if (n) {
          const o = s.indexOf(n);
          o > -1 && s.splice(o, 1);
        } else
          delete e[t];
    },
    emit(t, n) {
      const s = e[t] || [];
      return De(s, (o) => o(n));
    }
  };
};
class nt {
  constructor(t, n, s, o) {
    this.s = t, this.k = n, this.$dhy = s, this.$exp = o;
  }
  get v() {
    return this.$dhy(this.s);
  }
  get e() {
    return this.$exp(this.s);
  }
}
class pn extends nt {
  constructor(t, n, s, o, l) {
    super(t, n, s, o), this.$upd = l;
  }
  set v(t) {
    this.$upd(this.s, t);
  }
  get v() {
    return super.v;
  }
}
const jo = (e, t) => {
  let n = Co;
  return function(...o) {
    const l = e.bind(this, ...o), u = we(t) ? t : t(...o);
    n && Ft(n), u > 0 ? n = Qe(l, u) : l();
  };
}, Ho = (e, t) => {
  const n = {};
  for (const s in e)
    n[s] = t(e[s], s, e);
  return n;
};
var Ce;
(function(e) {
  e[e.USE_REQUEST = 1] = "USE_REQUEST", e[e.USE_WATCHER = 2] = "USE_WATCHER", e[e.USE_FETCHER = 3] = "USE_FETCHER";
})(Ce || (Ce = {}));
function Fn(e, t = { trackedKeys: {}, bindError: O, ...Fo() }) {
  const n = (i) => e.ref ? e.ref(i) : { current: i };
  t = n(t).current;
  const s = (i) => (e.export || Eo)(i, t), o = (i) => {
    if (!me(e.memorize))
      return i;
    const c = e.memorize(i);
    return c.memorized = U, c;
  }, { dehydrate: l } = e, u = (i, c, h) => i !== l(c, h, t) && t.trackedKeys[h] && e.update(i, c, h, t), f = (i) => De(i, (c) => Oe(c, nt) ? c.e : c), m = [], r = {};
  return {
    create: (i, c) => (Ke(m, c), pe(pn, e.create(i, c, t), c, (h) => l(h, c, t), s, (h, p) => u(p, h, c))),
    computed: (i, c, h) => (Be(c, (p) => {
      p.k && (r[p.k] = U);
    }), pe(nt, e.computed(i, f(c), h, t), h, (p) => l(p, h, t), s)),
    effectRequest: (i) => e.effectRequest(i, t),
    ref: n,
    watch: (i, c) => e.watch(f(i), c, t),
    onMounted: (i) => e.onMounted(i, t),
    onUnmounted: (i) => e.onUnmounted(i, t),
    memorize: o,
    /**
     * refering object that sharing some value with this object.
     */
    __referingObj: t,
    /**
     * expose provider for specified use hook.
     * @param object object that contains state proxy, framework state, operating function and event binder.
     * @returns provider component.
     */
    exposeProvider: (i) => {
      const c = {}, h = {}, p = [];
      for (const k in i) {
        const b = i[k];
        if (me(b) && !t.trackedKeys[k])
          c[k] = k.startsWith("on") ? (...C) => (b(...C), F) : b.memorized ? b : o(b);
        else {
          !ot(["uploading", "downloading"], k) && !k.startsWith("__") && Ke(p, k);
          const C = Oe(b, nt);
          C && (h[k] = b.s), Ge.defineProperty(c, k, {
            get: () => (t.trackedKeys[k] = U, C ? b.e : b),
            // set need to set an function,
            // otherwise it will throw `TypeError: Cannot set property __referingObj of #<Object> which has only a getter` when setting value
            set: Se,
            enumerable: U,
            configurable: U
          });
        }
      }
      const { update: x, __proxyState: T } = c;
      t.trackedKeys = {
        ...r
      }, t.bindError = O;
      const { then: M } = c, E = {
        // expose referingObject automatically.
        __referingObj: t,
        // the new updating function that can update the new states and nested hook states.
        update: o((k) => {
          Mn(k).forEach((b) => {
            ot(m, b) ? u(k[b], h[b], b) : b in c && me(x) && x({
              [b]: k[b]
            });
          });
        }),
        __proxyState: o((k) => ot(m, k) && Oe(i[k], nt) ? (t.trackedKeys[k] = U, i[k]) : T(k)),
        /**
         * send and wait for responding with `await`
         * this is always used in `nuxt3`
         * @example
         * ```js
         * const { loading, data, error } = await useRequest(...);
         * ```
         */
        then(k) {
          Be(p, (N) => {
            t.trackedKeys[N] = U;
          });
          const b = () => {
            Bt(F, "then"), k(F);
          };
          me(M) ? M(b) : b();
        }
      }, F = bt(c, E);
      return F;
    },
    /**
     * transform state proxies to object.
     * @param states proxy array of framework states
     * @param filterKey filter key of state proxy
     * @returns an object that contains the states of target form
     */
    objectify: (i, c) => i.reduce((h, p) => (h[p.k] = c ? p[c] : p, h), {}),
    transformState2Proxy: (i, c) => pe(pn, i, c, (h) => l(h, c, t), s, (h, p) => u(p, h, c))
  };
}
const Wo = wt("useRequest"), Vn = wt("useWatcher"), jn = wt("useFetcher"), Hn = (e) => ({
  [Ce.USE_REQUEST]: Wo,
  [Ce.USE_WATCHER]: Vn,
  [Ce.USE_FETCHER]: jn
})[e], Wn = (e, t) => e(Oe(t, Ln), "expected a method instance."), jt = "success", Ht = "error", Wt = "complete";
var qo = (e, t, n, s) => ({
  /** The method instance of the last request */
  m: L,
  /** sent method keys */
  rf: {},
  /** frontStates */
  fs: {},
  /** eventManager */
  em: n,
  /** hookType, useRequest=1, useWatcher=2, useFetcher=3 */
  ht: e,
  /** hook config */
  c: t,
  /** referingObject */
  ro: s,
  /** merged states */
  ms: {}
});
class Ae {
  constructor(t, n) {
    this.method = t, this.args = n;
  }
  clone() {
    return { ...this };
  }
  static spawn(t, n) {
    return pe(Ae, t, n);
  }
}
class Yo extends Ae {
  constructor(t, n, s) {
    super(t.method, t.args), this.data = n, this.fromCache = s;
  }
}
class Bo extends Ae {
  constructor(t, n) {
    super(t.method, t.args), this.error = n;
  }
}
class mn extends Ae {
  constructor(t, n, s, o, l) {
    super(t.method, t.args), this.status = n, this.data = s, this.fromCache = n === "error" ? !1 : o, this.error = l;
  }
}
const Ko = (e, t) => t(), ht = {}, Go = (e, t) => {
  const n = ht[e] || {};
  return n[t] ? Array.from(n[t]) : [];
}, Qo = (e, t, n) => {
  const s = ht[e] = ht[e] || {};
  s[t] || (s[t] = pe(Set)), s[t].add(n);
}, Xo = (e, t, n) => {
  const s = ht[e], o = s[t];
  s && o && (n ? o.delete(n) : o.clear(), o.size === 0 && Bt(s, t));
};
function qt(e, t, n = []) {
  const s = Hn(e.ht);
  let o = On(t, s, n);
  const { fs: l, ht: u, c: f } = e, { loading: m, data: r, error: i } = l, c = u === Ce.USE_FETCHER, { force: h = O, middleware: p = Ko } = f, x = Nn(o), { id: T } = x, M = Ue(o), { abortLast: E = U } = f, F = !e.m;
  return e.m = o, (async () => {
    let k = Se, b = O, N = In(L), C = Se, w = Se;
    const z = await At(o);
    let S = () => !!z, D = O;
    c || (Qo(T, M, e), k = () => Xo(T, M, e));
    const I = (V) => {
      b = U;
      const { force: he = h, method: P = o } = V || {}, H = An(he, [
        pe(Ae, o, n)
      ]), se = (Ie) => ({ loaded: xe, total: Je }) => {
        l[Ie].v = {
          loaded: xe,
          total: Je
        };
      };
      o = P, e.rf[M] = k, D || (m.v = !!H || !z);
      const { downloading: He, uploading: Le } = e.ro.trackedKeys;
      return C = He ? o.onDownload(se("downloading")) : C, w = Le ? o.onUpload(se("uploading")) : w, N = o.send(H), S = () => o.fromCache || O, N;
    }, de = {
      method: o,
      cachedResponse: z,
      config: f,
      abort: () => o.abort()
    }, Ee = () => u !== Ce.USE_WATCHER || !E || e.m === o, B = (V = U) => {
      V && F && (m.v = O), D = V;
    }, Ve = p(c ? {
      ...de,
      args: n,
      fetch: (V, ...he) => (Wn(s, V), qt(e, V, he)),
      proxyStates: Io(l, "data"),
      controlLoading: B
    } : {
      ...de,
      args: n,
      send: (...V) => qt(e, t, V),
      proxyStates: l,
      controlLoading: B
    }, I);
    let je = L;
    const te = Ae.spawn(o, n);
    try {
      const V = await Ve, he = (P) => (c ? e.c.updateState !== O && Be(Go(T, M), (H) => {
        H.fs.data.v = P;
      }) : Ee() && (r.v = P), Ee() && (i.v = L, !D && (m.v = O), e.em.emit(jt, pe(Yo, te, P, S())), e.em.emit(Wt, pe(mn, te, jt, P, S(), L))), P);
      je = // When no data is returned or undefined is returned in the middleware, get the real response data
      // Otherwise, use the returned data and no longer wait for the response promise. At this time, you also need to call the response callback.
      V !== L ? he(V) : b ? (
        // There are two possibilities when middlewareCompletePromise is resolve
        // 1. The request is normal
        // 2. The request is incorrect, but the error is captured by the middleware function. At this time, the success callback will also be called, that is, afterSuccess(undefinedValue)
        await Yt(N, he, () => he(L))
      ) : (
        // If is next called is not called, no data is returned
        L
      ), !b && !D && (m.v = O);
    } catch (V) {
      throw Ee() && (i.v = V, !D && (m.v = O), e.em.emit(Ht, pe(Bo, te, V)), e.em.emit(Wt, pe(mn, te, Ht, L, S(), V))), V;
    }
    return C(), w(), je;
  })();
}
const vn = (e) => e.current;
function Gt(e, t, n, s, o = O, l, u = 0) {
  var f;
  n = { ...n };
  let m = !!o, r = L;
  if (o)
    try {
      const P = On(t, Hn(e)), H = Nn(P), se = H.l1Cache.get(Oo(H.id, Ue(P)));
      if (se && !Oe(se, it)) {
        const [Le, Ie] = se;
        (!Ie || Ie > vt()) && (r = Le);
      }
      m = !!An((f = n.force) !== null && f !== void 0 ? f : O) || !r;
    } catch {
    }
  const { create: i, effectRequest: c, ref: h, objectify: p, exposeProvider: x, transformState2Proxy: T, __referingObj: M } = Fn(Rn(), n.__referingObj), E = {
    total: 0,
    loaded: 0
  }, { managedStates: F = {} } = n, k = Ho(F, (P, H) => T(P, H)), b = i(r ?? (me(s) ? s() : s), "data"), N = i(m, "loading"), C = i(L, "error"), w = i({ ...E }, "downloading"), z = i({ ...E }, "uploading"), S = p([b, N, C, w, z]), D = Vo(), I = vn(h(qo(e, n, D, M)));
  I.fs = S, I.em = D, I.c = n, I.ms = { ...S, ...k };
  const de = l !== L, Ee = (P = t, H) => qt(I, P, H), B = h(L), Ve = h(O), je = vn(h(zo())), te = (P = M, H) => {
    je(() => {
      (!go.ssr || B.current) && (Ve.current = U, ft(dt(Ee(H), (se) => {
        if (!P.bindError && !P.trackedKeys.error)
          throw se;
      }), () => {
        B.current && B.current();
      }));
    });
  }, V = h(jo((P, H, se) => te(H, se), (P) => we(P) ? mt(u) ? u[P] : u : 0));
  c({
    handler: (
      // When `watchingStates` is an array, it indicates the watching states (including an empty array). When it is undefined, it indicates the non-watching state.
      de ? (P) => V.current(P, M, t) : () => te(M)
    ),
    removeStates: () => {
      Be(zn(I.rf), (P) => P());
    },
    frontStates: { ...S, ...k },
    watchingStates: l,
    immediate: o ?? U
  });
  const he = x({
    ...p([b, N, C, w, z]),
    abort: () => I.m && I.m.abort(),
    /**
     * Manually initiate a request by executing this method
     * @param sendCallingArgs Parameters passed in when calling the send function
     * @param methodInstance method object
     * @param isFetcher Whether to call isFetcher
     * @returns Request promise
     */
    send: (P, H) => Ee(H, P),
    onSuccess(P) {
      D.on(jt, P);
    },
    onError(P) {
      M.bindError = U, D.on(Ht, P);
    },
    onComplete(P) {
      D.on(Wt, P);
    },
    /**
     * send and wait for responding with `await`
     * this is always used in `nuxt3` and `<suspense>` in vue3
     * @example
     * ```js
     * const { loading, data, error } = await useRequest(...);
     * ```
     */
    then(P) {
      const H = () => {
        P(he);
      }, { resolve: se, promise: He } = Un();
      B.current = se, Qe(() => {
        !Ve.current && se();
      }, 10), Yt(He, H, H);
    }
  });
  return he;
}
function Jo(e = {}) {
  const t = Gt(Ce.USE_FETCHER, Se, e), { send: n } = t;
  return Bt(t, "send"), bt(t, {
    /**
     * Fetch data fetch will definitely send a request, and if the currently requested data has a corresponding management state, this state will be updated.
     * @param matcher Method object
     */
    fetch: (s, ...o) => (Wn(jn, s), n(o, s))
  });
}
function Xe(e, t = {}) {
  const { immediate: n = U, initialData: s } = t, o = Gt(Ce.USE_REQUEST, e, t, s, !!n), { send: l } = o;
  return bt(o, {
    send: (...u) => l(u)
  });
}
function Zo(e, t, n = {}) {
  Vn(t && re(t) > 0, "expected at least one watching state");
  const { immediate: s, debounce: o = 0, initialData: l } = n, u = Gt(
    Ce.USE_WATCHER,
    e,
    n,
    l,
    !!s,
    // !!immediate means not send request immediately
    t,
    o
  ), { send: f } = u;
  return bt(u, {
    send: (...m) => f(m)
  });
}
var es = (e) => {
  let t = {};
  return {
    snapshots: () => t,
    save(n, s = O) {
      const o = Ue(n);
      (!t[o] || s) && (t[o] = {
        entity: n
      });
    },
    get: (n) => t[Ue(Oe(n, Ln) ? n : e(n))],
    remove(n) {
      n ? delete t[n] : t = {};
    }
  };
};
const ze = wt("usePagination"), hn = (e, t) => ze(we(e) && e < re(t), "index must be a number that less than list length"), gn = (e) => [
  e[e.length - 2],
  // refreshPage
  e[e.length - 1],
  // isRefresh
  e.slice(0, e.length - 2)
  // send args
];
var qn = (e, t = {}) => {
  const { create: n, computed: s, ref: o, watch: l, exposeProvider: u, objectify: f, __referingObj: m } = Fn(Rn()), { preloadPreviousPage: r = U, preloadNextPage: i = U, total: c = (_) => _.total, data: h = (_) => _.data, append: p = O, initialPage: x = 1, initialPageSize: T = 10, watchingStates: M = [], initialData: E, immediate: F = U, middleware: k, force: b = Se, actions: N = {}, ...C } = t, w = o(e), z = o(O), S = n(x, "page"), D = n(T, "pageSize"), I = n(E ? h(E) || [] : [], "data"), de = n(E ? c(E) : L, "total"), { snapshots: Ee, get: B, save: Ve, remove: je } = o(es((_) => w.current(_, D.v))).current, te = (_) => h(_) || _, V = Jo({
    __referingObj: m,
    updateState: O,
    force: ({ args: _ }) => _[re(_) - 1]
  }), { loading: he, fetch: P, abort: H, onSuccess: se } = V, He = o(he), Le = (_ = S.v, y = []) => {
    const $ = e(_, D.v, ...y);
    return Ve($), $;
  };
  l(M, () => {
    S.v = x, z.current = U;
  });
  const Ie = o({}), xe = n("", "status"), Je = n([], "removing"), xt = n(L, "replacing"), Ze = s(() => {
    const _ = de.v;
    return _ !== L ? Math.ceil(_ / D.v) : L;
  }, [D, de], "pageCount"), et = (_) => (...y) => Ie.current[_](...y), rt = Zo((..._) => {
    const [y, , $] = gn(_);
    return Le(y, $);
  }, [...M, S.e, D.e], {
    __referingObj: m,
    immediate: F,
    initialData: E,
    managedStates: f([I, S, D, de], "s"),
    middleware(_, y) {
      return k ? k({
        ..._,
        delegatingActions: {
          refresh: et("refresh"),
          insert: et("insert"),
          remove: et("remove"),
          replace: et("replace"),
          reload: et("reload"),
          getState: ($) => ({
            page: S,
            pageSize: D,
            data: I,
            pageCount: Ze,
            total: de,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            isLastPage: kt
          })[$].v
        }
      }, y) : y();
    },
    force: (_) => _.args[1] || (me(b) ? b(_) : b),
    ...C
  }), { send: lt } = rt, $t = rt.__proxyState("data"), Jt = async (_) => {
    const { rawData: y = $t.v, preloadPage: $, fetchMethod: R, forceRequest: j = O, isNextPage: q = O } = _, X = Ze.v, ne = X ? $ > X : q ? re(te(y)) < D.v : O;
    if (!($ > 0 && !ne))
      return O;
    const { e: K } = Mo(R), fe = await At(R);
    return K(Vt) <= vt() ? O : j || !fe;
  }, Zt = async (_, y, $ = []) => {
    const R = S.v + 1, j = Le(R, $);
    i && await Jt({
      rawData: _,
      preloadPage: R,
      fetchMethod: j,
      isNextPage: U,
      forceRequest: y
    }) && dt(P(j, ...$, y), Se);
  }, no = async (_, y = []) => {
    const $ = S.v - 1, R = Le($, y);
    r && await Jt({
      rawData: _,
      preloadPage: $,
      fetchMethod: R
    }) && dt(P(R, ...y, L), Se);
  }, St = () => {
    const _ = $t.v;
    if (!_)
      return U;
    const y = te(_), $ = S.v, R = Ze.v, j = mt(y) ? re(y) : 0;
    return R ? $ >= R : j < D.v;
  }, kt = n(St(), "isLastPage");
  l([S, Ze, $t, D], async () => {
    Qe(() => {
      kt.v = St();
    });
  });
  const Et = async () => {
    const _ = B(S.v);
    _ && await Mt(_.entity, (y) => {
      if (y) {
        const $ = te(y) || [];
        return We($, 0, re($), ...I.v), y;
      }
    });
  };
  se(({ method: _, data: y }) => {
    const $ = B(S.v);
    if ($ && Ue($.entity) === Ue(_)) {
      const R = te(y);
      if (p) {
        const j = I.v, q = D.v, X = re(j) % q;
        if (X > 0) {
          const ne = [...I.v];
          We(ne, (S.v - 1) * q, X, ...R), I.v = ne;
        }
      } else
        I.v = R;
    }
  });
  const Tt = o(L), Pt = o(L);
  rt.onSuccess(({ data: _, args: y, method: $ }) => {
    const [R, j, q] = gn(y), { total: X } = B($) || {}, ne = _;
    de.v = X !== L ? X : c(ne), j || (no(ne, q), Zt(ne, O, q));
    const Me = D.v, K = te(ne);
    if (ze(mt(K), "Got wrong array, did you return the correct array of list in `data` function"), p) {
      if (z.current && (I.v = []), R === L)
        I.v = [...I.v, ...K];
      else if (R) {
        const fe = [...I.v];
        We(fe, (R - 1) * Me, Me, ...K), I.v = fe;
      }
    } else
      I.v = K;
  }).onSuccess(({ data: _ }) => {
    var y;
    (y = Tt.current) === null || y === void 0 || y.call(Tt, _);
  }).onError(({ error: _ }) => {
    var y;
    (y = Pt.current) === null || y === void 0 || y.call(Pt, _);
  }).onComplete(() => {
    z.current = O;
  });
  const ct = (_) => {
    const y = I.v.indexOf(_);
    return ze(y >= 0, "item is not found in list"), y;
  }, { addQueue: Rt, onComplete: en } = o(Do()).current, Lt = async (_ = S.v) => {
    let y = _, $ = In();
    if (p) {
      if (!we(_)) {
        const R = ct(_);
        y = Math.floor(R / D.v) + 1;
      }
      ze(y <= S.v, "refresh page can't greater than page"), $ = lt(y, U);
    } else
      ze(we(y), "unable to calculate refresh page by item in pagination mode"), $ = y === S.v ? lt(L, U) : P(e(y, D.v), U);
    return $;
  }, tn = async (_ = O) => {
    const y = S.v, $ = Ee();
    let R = zn($);
    if (_)
      je();
    else {
      const j = De(pt([B(y - 1), B(y), B(y + 1)], Boolean), ({ entity: q }) => Ue(q));
      R = De(pt(Mn($), (q) => !ot(j, q)), (q) => {
        const X = $[q];
        return delete $[q], X;
      });
    }
    await _o(De(R, ({ entity: j }) => j));
  }, nn = async () => {
    He.current && H(), await tn();
    const _ = B(S.v + 1);
    if (_) {
      const y = te(await At(_.entity) || {}) || [];
      Zt(L, re(y) < D.v);
    }
  }, on = (_) => {
    if (_ === 0)
      return;
    const y = de.v;
    if (we(y)) {
      const $ = Math.max(y + _, 0);
      de.v = $;
      const R = S.v;
      Be([B(R - 1), B(R), B(R + 1)], (j) => {
        j && (j.total = $);
      });
    }
  }, sn = (_, y = 0) => (en(nn), Rt(async () => {
    const $ = we(y) ? y : ct(y) + 1;
    ze($ >= 0, "illegal insert position"), me(N.insert) && (xe.v = "inserting", await ft(N.insert(_, y), () => {
      xe.v = "";
    }));
    let R = L;
    const j = [...I.v];
    if (re(j) % D.v === 0 && (R = j.pop()), We(j, $, 0, _), I.v = j, on(1), await Et(), R) {
      const q = B(S.v + 1);
      q && await Mt(q.entity, (X) => {
        if (X) {
          const ne = te(X) || [];
          return ne.unshift(R), ne.pop(), X;
        }
      });
    }
  })), an = (..._) => (en(nn), Rt(async () => {
    const y = De(_, (K) => {
      const fe = we(K) ? K : ct(K);
      return hn(fe, I.v), fe;
    });
    if (me(N.remove)) {
      xe.v = "removing", Je.v = [...y];
      const K = xo(De(_, (fe) => N.remove(fe)));
      await ft(K, () => {
        xe.v = "", Je.v = [];
      });
    }
    const $ = S.v, R = $ + 1, j = B(R), q = [];
    j && await Mt(j.entity, (K) => {
      if (K) {
        const fe = te(K);
        return mt(fe) && Ke(q, ...We(fe, 0, re(y))), K;
      }
    });
    const X = St(), ne = re(q);
    let Me = !1;
    if (ne > 0 || X) {
      const K = pt(I.v, (fe, oo) => !ot(y, oo));
      Me = !p && X && re(K) <= 0, !Me && ne > 0 && Ke(K, ...q), I.v = K;
    } else ne <= 0 && !X && Lt($);
    return on(-re(y)), Et().then(() => {
      Me && (S.v = $ - 1);
    });
  })), rn = (_, y) => Rt(async () => {
    ze(y !== L, "expect specify the replace position");
    const $ = we(y) ? y : ct(y);
    hn($, I.v), me(N.replace) && (xe.v = "replacing", xt.v = $, await ft(N.replace(_, y), () => {
      xe.v = "", xt.v = L;
    }));
    const R = [...I.v];
    We(R, $, 1, _), I.v = R, await Et();
  }), ln = async () => {
    await tn(U), z.current = U, S.v === x ? dt(lt(), Se) : S.v = x;
    const { resolve: _, reject: y, promise: $ } = Un();
    return Tt.current = _, Pt.current = y, $;
  };
  return Ie.current = {
    refresh: Lt,
    insert: sn,
    remove: an,
    replace: rn,
    reload: ln
  }, u({
    ...rt,
    ...f([I, S, Ze, D, de, kt, xe, Je, xt]),
    send: (..._) => lt(..._, L, L),
    fetching: V.loading,
    onFetchSuccess: V.onSuccess,
    onFetchError: V.onError,
    onFetchComplete: V.onComplete,
    refresh: Lt,
    insert: sn,
    remove: an,
    replace: rn,
    reload: ln
  });
}, _n;
(function(e) {
  e[e.CONNECTING = 0] = "CONNECTING", e[e.OPEN = 1] = "OPEN", e[e.CLOSED = 2] = "CLOSED";
})(_n || (_n = {}));
var yn;
(function(e) {
  e.Open = "open", e.Error = "error", e.Message = "message";
})(yn || (yn = {}));
var ts = typeof global == "object" && global && global.Object === Object && global, ns = typeof self == "object" && self && self.Object === Object && self, Yn = ts || ns || Function("return this")(), gt = Yn.Symbol, Bn = Object.prototype, os = Bn.hasOwnProperty, ss = Bn.toString, tt = gt ? gt.toStringTag : void 0;
function as(e) {
  var t = os.call(e, tt), n = e[tt];
  try {
    e[tt] = void 0;
    var s = !0;
  } catch {
  }
  var o = ss.call(e);
  return s && (t ? e[tt] = n : delete e[tt]), o;
}
var is = Object.prototype, rs = is.toString;
function ls(e) {
  return rs.call(e);
}
var cs = "[object Null]", us = "[object Undefined]", bn = gt ? gt.toStringTag : void 0;
function ds(e) {
  return e == null ? e === void 0 ? us : cs : bn && bn in Object(e) ? as(e) : ls(e);
}
function fs(e) {
  return e != null && typeof e == "object";
}
var ps = "[object Symbol]";
function ms(e) {
  return typeof e == "symbol" || fs(e) && ds(e) == ps;
}
var vs = /\s/;
function hs(e) {
  for (var t = e.length; t-- && vs.test(e.charAt(t)); )
    ;
  return t;
}
var gs = /^\s+/;
function _s(e) {
  return e && e.slice(0, hs(e) + 1).replace(gs, "");
}
function _t(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var wn = NaN, ys = /^[-+]0x[0-9a-f]+$/i, bs = /^0b[01]+$/i, ws = /^0o[0-7]+$/i, Cs = parseInt;
function st(e) {
  if (typeof e == "number")
    return e;
  if (ms(e))
    return wn;
  if (_t(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = _t(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = _s(e);
  var n = bs.test(e);
  return n || ws.test(e) ? Cs(e.slice(2), n ? 2 : 8) : ys.test(e) ? wn : +e;
}
function xs(e, t, n) {
  return e === e && (n !== void 0 && (e = e <= n ? e : n), t !== void 0 && (e = e >= t ? e : t)), e;
}
function ut(e, t, n) {
  return n === void 0 && (n = t, t = void 0), n !== void 0 && (n = st(n), n = n === n ? n : 0), t !== void 0 && (t = st(t), t = t === t ? t : 0), xs(st(e), t, n);
}
var Dt = function() {
  return Yn.Date.now();
}, $s = "Expected a function", Ss = Math.max, ks = Math.min;
function Kn(e, t, n) {
  var s, o, l, u, f, m, r = 0, i = !1, c = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError($s);
  t = st(t) || 0, _t(n) && (i = !!n.leading, c = "maxWait" in n, l = c ? Ss(st(n.maxWait) || 0, t) : l, h = "trailing" in n ? !!n.trailing : h);
  function p(C) {
    var w = s, z = o;
    return s = o = void 0, r = C, u = e.apply(z, w), u;
  }
  function x(C) {
    return r = C, f = setTimeout(E, t), i ? p(C) : u;
  }
  function T(C) {
    var w = C - m, z = C - r, S = t - w;
    return c ? ks(S, l - z) : S;
  }
  function M(C) {
    var w = C - m, z = C - r;
    return m === void 0 || w >= t || w < 0 || c && z >= l;
  }
  function E() {
    var C = Dt();
    if (M(C))
      return F(C);
    f = setTimeout(E, T(C));
  }
  function F(C) {
    return f = void 0, h && s ? p(C) : (s = o = void 0, u);
  }
  function k() {
    f !== void 0 && clearTimeout(f), r = 0, s = m = o = f = void 0;
  }
  function b() {
    return f === void 0 ? u : F(Dt());
  }
  function N() {
    var C = Dt(), w = M(C);
    if (s = arguments, o = this, m = C, w) {
      if (f === void 0)
        return x(m);
      if (c)
        return clearTimeout(f), f = setTimeout(E, t), p(m);
    }
    return f === void 0 && (f = setTimeout(E, t)), u;
  }
  return N.cancel = k, N.flush = b, N;
}
var Es = "Expected a function";
function Gn(e, t, n) {
  var s = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(Es);
  return _t(n) && (s = "leading" in n ? !!n.leading : s, o = "trailing" in n ? !!n.trailing : o), Kn(e, t, {
    leading: s,
    maxWait: t,
    trailing: o
  });
}
var Ts = Object.defineProperty, Ps = Object.defineProperties, Rs = Object.getOwnPropertyDescriptors, Cn = Object.getOwnPropertySymbols, Ls = Object.prototype.hasOwnProperty, Is = Object.prototype.propertyIsEnumerable, xn = (e, t, n) => t in e ? Ts(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, yt = (e, t) => {
  for (var n in t || (t = {}))
    Ls.call(t, n) && xn(e, n, t[n]);
  if (Cn)
    for (var n of Cn(t))
      Is.call(t, n) && xn(e, n, t[n]);
  return e;
}, Qn = (e, t) => Ps(e, Rs(t));
const Ms = ["onPointerdown"], zs = {
  name: "ScrollbarThumb"
};
function Ds(e, { expose: t }) {
  const n = e;
  lo((w) => ({
    "1fb98f78": d(s)
  }));
  const s = ge(() => {
    var w;
    return `${(w = n.thumbWidth) != null ? w : 12}px`;
  });
  let o = null, l = $e(null);
  const u = { pageX: 0, pageY: 0, scrollPos: 0 };
  let f = null;
  const m = () => {
    o = setTimeout(() => {
      l.value && l.value.classList.remove("scrollbar__thumbPlaceholder--scrolling"), o = null;
    }, n.autoHideDelay);
  }, r = () => {
    o !== null && clearTimeout(o);
  };
  Ye(r);
  const i = Gn((w) => {
    w.stopPropagation(), w.preventDefault();
    const z = n.type === "horizontal" ? "pageX" : "pageY", S = (w[z] - u[z]) / n.scrollInfo.wrapperMainSize * n.scrollInfo.contentMainSize;
    n.wrapperEl.scrollTo({ [n.type === "horizontal" ? "left" : "top"]: u.scrollPos + S, behavior: "auto" });
  }, 16), c = () => {
    m(), l.value.removeEventListener("pointermove", i), l.value.removeEventListener("pointerup", c), l.value.removeEventListener("pointercancel", c), l.value.removeEventListener("mousewheel", c), document.removeEventListener("mousewheel", c), typeof f == "number" && l.value.releasePointerCapture(f), f = null;
  }, h = (w) => {
    w.ctrlKey || w.button !== 0 || (r(), u.pageX = w.pageX, u.pageY = w.pageY, u.scrollPos = n.wrapperEl[n.type === "horizontal" ? "scrollLeft" : "scrollTop"], f = w == null ? void 0 : w.pointerId, l.value.setPointerCapture(f), l.value.addEventListener("pointermove", i), l.value.addEventListener("pointerup", c), l.value.addEventListener("pointercancel", c), l.value.addEventListener("mousewheel", c, { passive: !1 }), document.addEventListener("mousewheel", c, { passive: !1 }), l.value.classList.add("scrollbar__thumbPlaceholder--scrolling"));
  };
  t({
    autoHideAfterScroll: () => {
      r(), l.value && l.value.classList.add("scrollbar__thumbPlaceholder--scrolling"), m();
    }
  });
  let x = $e(!1), T = $e(!1), M = $e(null), E = null, F = null, k = ge(() => n.fixedThumb && !T.value);
  const b = ([w]) => T.value = w.isIntersecting, N = ([w]) => x.value = w.isIntersecting, C = () => {
    E && (E.disconnect(), E = null), F && (F.disconnect(), F = null);
  };
  return be(() => [n.fixedThumb, n.wrapperEl], () => {
    if (!n.fixedThumb || !n.wrapperEl)
      return C();
    C(), F = new IntersectionObserver(N, { threshold: [0, 0.5] }), F.observe(n.wrapperEl), E = new IntersectionObserver(b), E.observe(M.value);
  }), Ye(C), (w, z) => (v(), g(oe, null, [
    W(a("div", {
      class: _e([
        "scrollbar__thumbPlaceholder",
        `scrollbar__thumbPlaceholder--${e.type}`,
        {
          "scrollbar__thumbPlaceholder--autoHide": e.autoHide,
          "scrollbar__thumbPlaceholder--autoExpand": e.autoExpand
        }
      ]),
      style: qe({
        width: e.type === "horizontal" ? `${e.scrollInfo.thumbSize}px` : "",
        height: e.type === "vertical" ? `${e.scrollInfo.thumbSize}px` : "",
        position: k.value ? "fixed" : "absolute",
        [e.type === "vertical" ? "top" : "left"]: k.value ? `${e.scrollInfo.boundaryDistance + 3}px` : "3px"
      }),
      ref: (S, D) => {
        D.thumbEl = S, l.value = S;
      },
      onPointerdown: at(h, ["stop"])
    }, [
      z[0] || (cn(-1), z[0] = a("div", {
        class: _e(["scrollbar__thumb", `scrollbar__thumb--${e.type}`])
      }, null, 2), cn(1), z[0])
    ], 46, Ms), [
      [un, !!e.scrollInfo.thumbSize && (e.fixedThumb ? x.value : !0)]
    ]),
    n.fixedThumb ? W((v(), g("div", {
      key: 0,
      ref: (S, D) => {
        D.shepherdEl = S, M.value = S;
      },
      class: _e(["scrollbar__shepherd", `scrollbar__shepherd--${e.type}`])
    }, null, 2)), [
      [un, !!e.scrollInfo.thumbSize]
    ]) : Y("", !0)
  ], 64));
}
const Ns = /* @__PURE__ */ En(Qn(yt({}, zs), {
  props: {
    type: null,
    autoExpand: null,
    autoHide: null,
    autoHideDelay: null,
    fixedThumb: null,
    scrollInfo: null,
    thumbWidth: null,
    wrapperEl: null
  },
  setup: Ds
})), Os = {
  wait: 333,
  type: "debounce"
};
function $n(...e) {
  const t = "value" in (e == null ? void 0 : e[0]);
  let n;
  t ? n = e == null ? void 0 : e[1] : n = e == null ? void 0 : e[0];
  const { wait: s, type: o, callback: l } = yt(yt({}, Os), n), u = t ? e[0] : $e(null), f = io({ left: 0, top: 0, right: 0, bottom: 0, width: 0, height: 0, x: 0, y: 0 }), m = () => {
    const h = u.value.getBoundingClientRect();
    f.left = h.left, f.top = h.top, f.right = h.right, f.bottom = h.bottom, f.width = h.width, f.height = h.height, f.x = h.x, f.y = h.y, l == null || l();
  };
  let r = null, i = null;
  const c = () => {
    r && window.removeEventListener("resize", r), i && (i.disconnect(), i = null);
  };
  return ro(() => {
    u.value && (c(), r = m, o === "throttle" && s >= 4 ? r = Gn(r, s) : o === "debounce" && s >= 4 && (r = Kn(r, s)), window.addEventListener("resize", r), i = new ResizeObserver(r), i.observe(u.value));
  }), Ye(c), t ? f : [u, f];
}
const Us = {
  name: "CustomScrollbar",
  inheritAttrs: !1
};
function As(e, { expose: t, emit: n }) {
  const s = e, o = {
    horizontal: { el: null, instance: null },
    vertical: { el: null, instance: null }
  }, l = (b, N) => {
    o[N].instance || (o[N].instance = b);
  };
  let u = $e(null), f = $e(null);
  Re(() => {
    var b;
    const N = Array.from((b = u.value.parentElement) == null ? void 0 : b.childNodes);
    for (const C in o)
      o[C].el = N.find((w) => {
        var z;
        return (z = w == null ? void 0 : w.classList) == null ? void 0 : z.contains(`scrollbar__thumbPlaceholder--${C}`);
      });
  });
  const m = $n(u, { wait: s.throttleWait, type: s.throttleType, callback: h }), r = $n(f, { wait: s.throttleWait, type: s.throttleType, callback: h });
  let i = $e(0), c = $e(0);
  function h() {
    i.value = Math.max(u.value.scrollHeight - m.height | 0, 0), c.value = Math.max(u.value.scrollWidth - m.width | 0, 0);
  }
  let p = ge(() => ({
    thumbSize: c.value ? ut(m.width / u.value.scrollWidth * m.width, s.thumbMinSize > m.width ? 48 : s.thumbMinSize, s.thumbMaxSize) : 0,
    contentMainSize: r.width,
    wrapperMainSize: m.width,
    boundaryDistance: Math.abs(m.left)
  })), x = ge(() => ({
    thumbSize: i.value ? ut(m.height / u.value.scrollHeight * m.height, s.thumbMinSize > m.height ? 48 : s.thumbMinSize, s.thumbMaxSize) : 0,
    contentMainSize: r.height,
    wrapperMainSize: m.height,
    boundaryDistance: Math.abs(m.top)
  })), T = ge(() => m.height - x.value.thumbSize - 5), M = ge(() => m.width - p.value.thumbSize - 5);
  const E = () => {
    c.value && (o.horizontal.el.style.transform = `translate3d(${u.value.scrollLeft / c.value * M.value}px, 0, 0)`, o.horizontal.instance.autoHideAfterScroll()), i.value && (o.vertical.el.style.transform = `translate3d(0, ${u.value.scrollTop / i.value * T.value}px, 0)`, o.vertical.instance.autoHideAfterScroll());
  };
  be(() => [c.value, i.value], E);
  const F = (b) => {
    b.stopPropagation();
    const N = u.value.scrollLeft, C = u.value.scrollTop, w = ut(N + ((b == null ? void 0 : b.deltaX) || 0), 0, c.value) | 0, z = ut(C + ((b == null ? void 0 : b.deltaY) || 0), 0, i.value) | 0;
    u.value.scrollLeft = w, u.value.scrollTop = z, c.value && (o.horizontal.el.style.transform = `translate3d(${w / c.value * M.value}px, 0, 0)`, o.horizontal.instance.autoHideAfterScroll()), i.value && (o.vertical.el.style.transform = `translate3d(0, ${z / i.value * T.value}px, 0)`, o.vertical.instance.autoHideAfterScroll()), n("scroll", { target: u.value, scrollLeft: w, scrollTop: z });
  }, k = (b) => {
    s.simulateScroll ? F(b) : E();
  };
  return be(m, () => n("wrapperResize", m)), be(r, () => n("contentResize", r)), t({
    scrollEl: u
  }), (b, N) => (v(), g("div", {
    class: _e(["scrollbar__wrapper", e.wrapperClass]),
    style: qe(e.wrapperStyle)
  }, [
    a("div", ao({
      ref: (C, w) => {
        w.wrapperEl = C, u.value = C;
      },
      class: "scrollbar__scroller"
    }, b.$attrs, {
      onWheel: k,
      onScroll: k
    }), [
      a("div", {
        ref: (C, w) => {
          w.contentEl = C, f.value = C;
        },
        class: _e(["scrollbar__content", e.contentClass, { "scrollbar__content--fixedThumb": e.fixedThumb, [`scrollbar__content--${e.direction}`]: e.direction }]),
        style: qe(e.contentStyle)
      }, [
        Tn(b.$slots, "default")
      ], 6)
    ], 16),
    (v(), g(oe, null, Fe(o, (C, w) => Z(Ns, {
      ref: (z) => l(z, w),
      key: w,
      autoExpand: e.autoExpand,
      autoHide: e.autoHide,
      autoHideDelay: e.autoHideDelay,
      fixedThumb: w === e.direction ? !1 : e.fixedThumb,
      type: w,
      scrollInfo: w === "vertical" ? x.value : p.value,
      thumbWidth: e.thumbWidth,
      wrapperEl: u.value
    }, null, 8, ["autoExpand", "autoHide", "autoHideDelay", "fixedThumb", "type", "scrollInfo", "thumbWidth", "wrapperEl"])), 64))
  ], 6));
}
const ke = /* @__PURE__ */ En(Qn(yt({}, Us), {
  props: {
    wrapperClass: null,
    wrapperStyle: null,
    contentClass: null,
    contentStyle: null,
    direction: { default: "vertical" },
    thumbMinSize: { default: 48 },
    thumbMaxSize: { default: 1 / 0 },
    thumbWidth: { default: 12 },
    autoHide: { default: !0 },
    autoHideDelay: { default: 900 },
    autoExpand: { default: !0 },
    fixedThumb: null,
    throttleType: { default: "debounce" },
    throttleWait: { default: 333 },
    simulateScroll: null
  },
  emits: ["wrapperResize", "contentResize", "scroll"],
  setup: As
}));
class Fs extends CustomEvent {
  constructor(t) {
    super("LUTE:AUTH:EXPIRED", { detail: t });
  }
}
const Xn = "momcozy-token";
function Vs() {
  const t = new URLSearchParams(location.search).get("__dev__") === "true" || sessionStorage.getItem("__dev__") === "true";
  return t && !sessionStorage.getItem("__dev__") && sessionStorage.setItem("__dev__", "true"), t;
}
function js() {
  return Vs() ? "https://station-dev.luteshop.com" : "https://account.momcozy.com";
}
function Hs(e) {
  const n = document.cookie.split(";").find((s) => s.trim().startsWith(`${e}=`));
  return n ? n.trim().substring(e.length + 1) : null;
}
function Ws(e, t = window.location.hostname) {
  document.cookie = `${e}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${t}; SameSite=Lax`;
}
function Qt() {
  return Hs(Xn);
}
function qs() {
  Ws(Xn);
}
function Ys(e) {
  document.dispatchEvent(new Fs(e));
}
const Bs = (e) => To(e) || Lo(e);
function Ks() {
  return (e, t) => {
    const n = t.config, s = n.timeout || 0, o = new AbortController(), { data: l, headers: u } = e, f = /content-type/i.test(Ge.keys(u).join()), m = l && l.toString() === "[object FormData]";
    !f && !m && (u["Content-Type"] = "application/json;charset=UTF-8");
    const r = fetch(e.url, {
      ...n,
      method: e.type,
      signal: o.signal,
      body: Bs(l) ? l : $o(l)
    });
    let i, c = O;
    return s > 0 && (i = Qe(() => {
      c = U, o.abort();
    }, s)), {
      response: () => r.then((h) => (Ft(i), h.clone()), (h) => wo(c ? pe(Error, "fetchError: network timeout") : h)),
      // The then in the Headers function needs to catch exceptions, otherwise the correct error object will not be obtained internally.
      headers: () => r.then(({ headers: h }) => h, () => ({})),
      // Due to limitations of the node fetch library, this code cannot be unit tested, but it has passed the test in the browser.
      /* c8 ignore start */
      onDownload: async (h) => {
        let p = O;
        const x = await r.catch(() => {
          p = U;
        });
        if (!x)
          return;
        const { headers: T, body: M } = x.clone(), E = M ? M.getReader() : L, F = Number(T.get("Content-Length") || T.get("content-length") || 0);
        if (F <= 0)
          return;
        let k = 0;
        if (E) {
          const b = () => E.read().then(({ done: N, value: C = new Uint8Array() }) => {
            if (N || p)
              p && h(k, 0);
            else
              return k += C.byteLength, h(k, F), b();
          });
          b();
        }
      },
      onUpload() {
        console.error("fetch API does'nt support uploading progress. please consider to change `@alova/adapter-xhr` or `@alova/adapter-axios`");
      },
      /* c8 ignore stop */
      abort: () => {
        o.abort(), Ft(i);
      }
    };
  };
}
var Gs = {
  name: "Vue",
  create: (e) => Q(e),
  dehydrate: (e) => e.value,
  update: (e, t) => {
    t.value = e;
  },
  effectRequest({ handler: e, removeStates: t, immediate: n, watchingStates: s }) {
    It() && Ye(t), n && e(), Be(s || [], (o, l) => {
      be(o, () => {
        e(l);
      }, { deep: U });
    });
  },
  computed: (e) => ge(e),
  watch: (e, t) => {
    be(e, t, {
      deep: U
    });
  },
  onMounted: (e) => {
    It() ? Re(e) : Qe(e, 10);
  },
  onUnmounted: (e) => {
    It() && Ye(e);
  }
};
const Qs = js(), ye = yo({
  baseURL: Qs,
  requestAdapter: Ks(),
  statesHook: Gs,
  cacheFor: null,
  beforeRequest(e) {
    e.config.headers["Content-Type"] = "application/json", e.config.headers.authorization = `Bearer ${Qt()}`;
  },
  responded: async (e) => {
    if (e.status !== 200)
      throw new Error(`[${e.status}]${e.statusText}`);
    const t = await e.json();
    if (t.code !== "200") {
      t.code === "10001003" && Ys(t);
      const n = new Error(`[${t.code}]${t.message}`);
      throw n.response = t, n;
    }
    return t.result;
  }
});
function Xs() {
  return ye.Get("/api/station/user/getUserInfo/v2").send(!0);
}
function Js(e) {
  return ye.Get("/api/station/point/getPointDetailPageListNew", { params: e });
}
function Zs(e) {
  return ye.Get("/api/station/point/tasks", { params: e, transform: (t) => t.pointEventList || [] });
}
function ea(e) {
  return ye.Get("/api/station/point/tasksNew", { params: e, transform: (t) => t.pointEventList || [] });
}
function ta(e) {
  return ye.Post("/api/station/point/task/do", e);
}
function na(e) {
  return ye.Get("/api/station/point/getProductsNew", { params: e, transform: (t) => t.pointProductRespList || [] });
}
function oa(e) {
  return ye.Get("/api/station/point/getAllProducts", { params: e, transform: (t) => t.pointProductRespList || [] });
}
function Jn(e) {
  return ye.Post("/api/station/point/exchangeProductNew", e);
}
function sa(e) {
  return ye.Get("/api/station/point/exchangeProductHistory", { params: e });
}
async function aa(e) {
  return await ye.Get(`/api/station/point/getPointProductUrl/${e}`);
}
function ia(e) {
  return ye.Post("/api/station/user/subscribe", e);
}
function ra(e) {
  return ye.Post("/api/station/user/subscribePhone", e);
}
const ee = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, o] of t)
    n[s] = o;
  return n;
}, la = {}, ca = { class: "list" };
function ua(e, t) {
  return v(), g("ul", ca, t[0] || (t[0] = [
    co('<li class="redeem-item skeletonCard skeletonCard--shine"><div class="info"><div class="title skeletonText skeletonText--long"></div><div class="date skeletonText"></div></div><div class="count skeletonText skeletonText--short"></div></li><li class="line"></li><li class="redeem-item skeletonCard skeletonCard--shine"><div class="info"><div class="title skeletonText skeletonText--long"></div><div class="date skeletonText"></div></div><div class="count skeletonText skeletonText--short"></div></li>', 3)
  ]));
}
const Ct = /* @__PURE__ */ ee(la, [["render", ua]]), da = {
  key: 0,
  class: "redeem-toast"
}, fa = { class: "msg" }, pa = {
  __name: "Toast",
  props: {
    teleportTarget: {
      type: String,
      default: "#lute-redeem-app-page"
    },
    icon: {
      type: String,
      default: "icon-circletick"
    },
    message: {
      type: String,
      required: !0
    },
    duration: {
      type: Number,
      default: 2e3
    },
    onClose: {
      type: Function,
      default: () => {
      }
    }
  },
  setup(e) {
    const t = e, n = Q(!1);
    return Re(() => {
      n.value = !0, setTimeout(() => {
        n.value = !1, setTimeout(() => {
          t.onClose();
        }, 300);
      }, t.duration);
    }), (s, o) => (v(), le(uo, { to: e.teleportTarget }, [
      Z(Ot, { name: "toast-fade" }, {
        default: ce(() => [
          n.value ? (v(), g("div", da, [
            a("i", {
              class: _e(["lutefont", e.icon])
            }, null, 2),
            a("div", fa, A(e.message), 1)
          ])) : Y("", !0)
        ]),
        _: 1
      })
    ], 8, ["to"]));
  }
};
let Te = null;
function ae(e) {
  Te && (document.body.removeChild(Te.el), Te = null), typeof e == "string" && (e = { message: e });
  const t = document.createElement("div"), n = () => {
    e.onClose && e.onClose(), dn(null, t), document.body.removeChild(t), Te = null;
  }, s = Z(pa, {
    ...e,
    onClose: n
  });
  return dn(s, t), document.body.appendChild(t), Te = {
    el: t,
    close: n
  }, Te;
}
ae.close = () => {
  Te && Te.close();
};
const Pe = {};
function ma(e, t) {
  return Pe[e] === void 0 && (Pe[e] = []), Pe[e] = [...Pe[e], t], function() {
    Pe[e] = Pe[e].filter((s) => s !== t);
  };
}
function Zn(e, t) {
  Pe[e] && Pe[e].forEach((n) => {
    n();
  });
}
function va() {
  window.T4SThemeSP.Drawer.opend(window.$("#t4s-mini_cart"));
}
const Ne = "https://account.momcozy.com", Xt = `${Ne}/login?redirect=${encodeURIComponent(`${window.location.href}?lt-redeem=true`)}`, ha = { class: "redeem-list" }, ga = { class: "header" }, _a = { class: "ctx" }, ya = ["href"], ba = {
  key: 1,
  class: "balance"
}, wa = {
  key: 1,
  class: "list"
}, Ca = ["onClick"], xa = { class: "info" }, $a = { class: "title" }, Sa = { class: "date" }, ka = {
  key: 0,
  class: "operate"
}, Ea = {
  key: 0,
  class: "lutefont icon-circletick"
}, Ta = {
  key: 0,
  class: "btn loading loading-btn"
}, Pa = {
  key: 0,
  class: "icon lutefont icon-loading"
}, Ra = {
  key: 0,
  class: "loading"
}, La = {
  key: 1,
  class: "lutefont icon-arrow"
}, Ia = /* @__PURE__ */ Object.assign({
  name: "Coins"
}, {
  __name: "Coins",
  setup(e) {
    const t = ue(), n = ie(), { userinfo: s } = J(n), o = ge(() => s.value ? Zs : ea), { loading: l, data: u, send: f } = Xe(() => o.value({ completionStatus: 2 }), { initialData: [] });
    ma("update:task:list", f);
    async function m(r) {
      if (!s.value) {
        window.location.href = Ne;
        return;
      }
      r.type === 23 ? t.setComp("email", r) : r.type === 28 ? t.setComp("sms", r) : [24, 25, 26, 27].includes(r.type) ? (ta({ eventType: +r.type }).then(() => {
        f(), n.updateUserinfo();
      }), window.open(r.jumpLink, "_blank")) : r.type === 29 ? va() : r.type === 22 ? window.open(`${Ne}?dialog=baby`, "_blank") : r.type === 21 ? window.open(`${Ne}?dialog=user`, "_blank") : window.open(Ne, "_blank");
    }
    return (r, i) => {
      var h;
      const c = ve("track");
      return v(), g("div", ha, [
        a("div", ga, [
          a("i", {
            class: "lutefont icon-arrow-left",
            onClick: i[0] || (i[0] = (...p) => d(t).back && d(t).back(...p))
          }),
          i[2] || (i[2] = a("h2", null, "Earn CozyCoins", -1)),
          a("i", {
            class: "lutefont icon-close",
            onClick: i[1] || (i[1] = (...p) => d(t).toggle && d(t).toggle(...p))
          })
        ]),
        a("div", _a, [
          d(s) ? (v(), g("div", ba, [
            i[4] || (i[4] = G(" My CozyCoins: ", -1)),
            a("strong", null, A((h = d(s)) == null ? void 0 : h.points), 1)
          ])) : W((v(), g("a", {
            key: 0,
            href: d(Xt),
            class: "balance link"
          }, i[3] || (i[3] = [
            a("strong", null, "Log In >", -1)
          ]), 8, ya)), [
            [c, { from: "coins" }, "login"]
          ]),
          Z(d(ke), { "wrapper-class": "list-wrapper" }, {
            default: ce(() => [
              d(l) ? (v(), le(Ct, { key: 0 })) : (v(), g("ul", wa, [
                (v(!0), g(oe, null, Fe(d(u), (p) => (v(), g(oe, {
                  key: p.title
                }, [
                  W((v(), g("li", {
                    class: _e(["redeem-item", { completed: p.completionStatus === 1 }]),
                    onClick: at((x) => m(p), ["stop"])
                  }, [
                    i[7] || (i[7] = a("div", { class: "icon" }, [
                      a("i", { class: "lutefont icon-gift" })
                    ], -1)),
                    a("div", xa, [
                      a("div", $a, A(p.title), 1),
                      a("div", Sa, A(p.type === 29 ? p.desc : `${p.pointsDesc} CozyCoins`), 1)
                    ]),
                    d(s) ? (v(), g("div", ka, [
                      p.completionStatus === 1 ? (v(), g("i", Ea)) : (v(), g(oe, { key: 1 }, [
                        p.type === 23 || p.type === 28 ? (v(), g("button", Ta, [
                          p.loading ? (v(), g("i", Pa)) : Y("", !0),
                          i[5] || (i[5] = G(" Set ", -1))
                        ])) : (v(), g(oe, { key: 1 }, [
                          p.loading ? (v(), g("div", Ra, i[6] || (i[6] = [
                            a("i", { class: "icon lutefont icon-loading" }, null, -1)
                          ]))) : (v(), g("i", La))
                        ], 64))
                      ], 64))
                    ])) : Y("", !0)
                  ], 10, Ca)), [
                    [c, { type: p.type, item: p.title, completed: p.completionStatus }, "task"]
                  ]),
                  i[8] || (i[8] = a("li", { class: "line" }, null, -1))
                ], 64))), 128))
              ]))
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), Ma = /* @__PURE__ */ ee(Ia, [["__scopeId", "data-v-566f9470"]]), Nt = {
  mounted(e, t) {
    let n = null, s = 0, o = 400;
    const l = (r) => r >= 2500 ? 100 : 300 - 200 * (r / 2500), u = () => {
      var i, c;
      typeof ((i = t.value) == null ? void 0 : i.handler) == "function" && t.value.handler((c = t.value) == null ? void 0 : c.arg);
      const r = Date.now() - s;
      o = l(r), n = setTimeout(u, o);
    }, f = () => {
      var r, i;
      n || (typeof ((r = t.value) == null ? void 0 : r.handler) == "function" && t.value.handler((i = t.value) == null ? void 0 : i.arg), s = Date.now(), o = 400, n = setTimeout(u, o));
    }, m = () => {
      n && (clearTimeout(n), n = null), s = 0, o = 400;
    };
    e.__longpressStart__ = f, e.__longpressCancel__ = m, e.addEventListener("mousedown", f), e.addEventListener("touchstart", f), e.addEventListener("mouseup", m), e.addEventListener("mouseleave", m), e.addEventListener("touchend", m);
  },
  beforeUnmount(e) {
    e.removeEventListener("mousedown", e.__longpressStart__), e.removeEventListener("touchstart", e.__longpressStart__), e.removeEventListener("mouseup", e.__longpressCancel__), e.removeEventListener("mouseleave", e.__longpressCancel__), e.removeEventListener("touchend", e.__longpressCancel__), e.__longpressStart__ = null, e.__longpressCancel__ = null;
  }
}, za = { class: "number-input" }, Da = ["disabled"], Na = ["placeholder", "min", "max", "step"], Oa = ["disabled"], Ua = {
  __name: "NumberInput",
  props: /* @__PURE__ */ Ut({
    placeholder: {
      type: String,
      default: "Enter amount"
    },
    max: {
      type: Number,
      default: 1e6
    },
    min: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 100
    }
  }, {
    modelValue: {
      default: 100
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e;
    Re(() => {
      var u;
      typeof window < "u" && ((u = window == null ? void 0 : window.appContext) != null && u.app) && window.appContext.app.directive("longpress", Nt);
    });
    const n = Pn(e, "modelValue"), s = ge(() => n.value >= t.max), o = ge(() => n.value <= t.min);
    function l(u) {
      const f = n.value + u;
      if (f < t.min) {
        n.value = t.min;
        return;
      }
      if (f > t.max) {
        n.value = t.max;
        return;
      }
      n.value = f;
    }
    return (u, f) => (v(), g("div", za, [
      W((v(), g("button", {
        type: "button",
        disabled: o.value,
        class: "spin-btn"
      }, f[1] || (f[1] = [
        a("i", { class: "lutefont icon-minus" }, null, -1)
      ]), 8, Da)), [
        [d(Nt), { handler: l, arg: -100 }]
      ]),
      W(a("input", {
        "onUpdate:modelValue": f[0] || (f[0] = (m) => n.value = m),
        readonly: "",
        type: "number",
        placeholder: e.placeholder,
        min: e.min,
        max: e.max,
        step: e.step
      }, null, 8, Na), [
        [fo, n.value]
      ]),
      W((v(), g("button", {
        type: "button",
        disabled: s.value,
        class: "spin-btn plus"
      }, f[2] || (f[2] = [
        a("i", { class: "lutefont icon-plus" }, null, -1)
      ]), 8, Oa)), [
        [d(Nt), { handler: l, arg: 100 }]
      ])
    ]));
  }
}, Aa = /* @__PURE__ */ ee(Ua, [["__scopeId", "data-v-2def76fa"]]), Fa = { class: "redeem-list" }, Va = { class: "header" }, ja = { class: "ctx" }, Ha = { class: "balance" }, Wa = { class: "list" }, qa = {
  class: "redeem-form",
  action: "#"
}, Ya = { class: "form-item" }, Ba = 3e3, Ka = /* @__PURE__ */ Object.assign({
  name: "CovertCoins"
}, {
  __name: "CovertCoins",
  setup(e) {
    const t = ie(), { userinfo: n } = J(t), { updateUserinfo: s } = t, o = Q(100), l = ue(), { pageData: u } = J(l);
    function f(h) {
      return typeof h != "number" || Number.isNaN(h) ? 0 : Math.floor(h / 100) * 100;
    }
    const { send: m } = Xe((h) => Jn(h), { immediate: !1 });
    function r() {
      o.value = f(Math.min(n.value.points, Ba));
    }
    r();
    const i = Q(!1);
    async function c() {
      var h;
      i.value = !0;
      try {
        const p = await m({ productCode: u.value.productCode, usedPoints: o.value, number: 1, source: window.innerWidth < 768 ? 5 : 4 });
        await s(), r(), (p == null ? void 0 : p.redeemStatus) === 0 ? (ae("Redeemed successfully !"), l.back({ type: "rewards" })) : ae({
          message: p.message || "Redemption Failed !",
          icon: "icon-error"
        });
      } catch (p) {
        ae({
          message: ((h = p.response) == null ? void 0 : h.message) || "Redemption Failed !",
          icon: "icon-error"
        });
      } finally {
        i.value = !1;
      }
    }
    return (h, p) => {
      var T;
      const x = ve("track");
      return v(), g("div", Fa, [
        a("div", Va, [
          a("i", {
            class: "lutefont icon-arrow-left",
            onClick: p[0] || (p[0] = (M) => d(l).back())
          }),
          p[2] || (p[2] = a("h2", null, "Earn CozyCoins", -1)),
          p[3] || (p[3] = a("i", { class: "lutefont icon-close" }, null, -1))
        ]),
        a("div", ja, [
          a("div", Ha, [
            p[4] || (p[4] = G(" My CozyCoins: ", -1)),
            a("strong", null, A((T = d(n)) == null ? void 0 : T.points), 1)
          ]),
          Z(d(ke), {
            "wrapper-class": "list-wrapper",
            "auto-hide": !1,
            "auto-expand": !1
          }, {
            default: ce(() => [
              a("div", Wa, [
                p[6] || (p[6] = a("div", { class: "redeem-item" }, [
                  a("div", { class: "icon" }, [
                    a("i", { class: "lutefont icon-gift" })
                  ]),
                  a("div", { class: "info" }, [
                    a("div", { class: "title" }, " CONVERT YOUR COZYCOINS "),
                    a("div", { class: "date" }, " 100 CozyCoins=$1 ")
                  ])
                ], -1)),
                p[7] || (p[7] = a("div", { class: "line" }, null, -1)),
                a("form", qa, [
                  a("div", Ya, [
                    Z(Aa, {
                      modelValue: o.value,
                      "onUpdate:modelValue": p[1] || (p[1] = (M) => o.value = M),
                      max: 3e3,
                      class: "form__number-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  a("p", null, A(`Redeem ${o.value} Points for $${(o.value / 100).toFixed(0)} off your next purchase`), 1),
                  W((v(), g("button", {
                    type: "submit",
                    class: "form-button",
                    onClick: c
                  }, p[5] || (p[5] = [
                    G(" Redeem ", -1)
                  ]))), [
                    [x, { type: d(u).productTyp, code: d(u).productCode, item: d(u).productName, usedPoints: o.value }, "exchange:detail"]
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), Ga = /* @__PURE__ */ ee(Ka, [["__scopeId", "data-v-0796ca20"]]), Qa = { class: "redeem-list" }, Xa = { class: "header" }, Ja = { class: "ctx" }, Za = { class: "balance" }, ei = { class: "list" }, ti = { class: "redeem-item" }, ni = { class: "info" }, oi = { class: "title" }, si = { class: "date" }, ai = { class: "info redeem-form" }, ii = {
  key: 0,
  class: "icon lutefont icon-loading"
}, ri = /* @__PURE__ */ Object.assign({
  name: "CovertDiscount"
}, {
  __name: "CovertDiscount",
  setup(e) {
    const t = ue(), { pageData: n } = J(t), s = ie(), { userinfo: o } = J(s), { updateUserinfo: l } = s, { send: u } = Xe(
      (r) => Jn(r),
      { immediate: !1 }
    ), f = Q(!1);
    async function m() {
      var r;
      f.value = !0;
      try {
        const i = await u({
          productCode: n.value.productCode,
          source: window.innerWidth < 768 ? 5 : 4
        });
        await l(), (i == null ? void 0 : i.redeemStatus) === 0 ? (ae("Redeemed successfully !"), t.back({ type: "rewards" })) : ae({
          message: i.message || "Redemption Failed !",
          icon: "icon-error"
        });
      } catch (i) {
        ae({
          message: ((r = i.response) == null ? void 0 : r.message) || "Redemption Failed !",
          icon: "icon-error"
        });
      } finally {
        f.value = !1;
      }
    }
    return (r, i) => {
      var h;
      const c = ve("track");
      return v(), g("div", Qa, [
        a("div", Xa, [
          a("i", {
            class: "lutefont icon-arrow-left",
            onClick: i[0] || (i[0] = (p) => d(t).back())
          }),
          i[2] || (i[2] = a("h2", null, "Earn CozyCoins", -1)),
          a("i", {
            class: "lutefont icon-close",
            onClick: i[1] || (i[1] = (...p) => d(t).toggle && d(t).toggle(...p))
          })
        ]),
        a("div", Ja, [
          a("div", Za, [
            i[3] || (i[3] = G(" My CozyCoins: ", -1)),
            a("strong", null, A((h = d(o)) == null ? void 0 : h.points), 1)
          ]),
          Z(d(ke), { "wrapper-class": "list-wrapper" }, {
            default: ce(() => [
              a("div", ei, [
                a("div", ti, [
                  i[4] || (i[4] = a("div", { class: "icon" }, [
                    a("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  a("div", ni, [
                    a("div", oi, A(d(n).productName), 1),
                    a("div", si, A(`${d(n).exchangePoint} Points`), 1)
                  ])
                ]),
                i[6] || (i[6] = a("div", { class: "line" }, null, -1)),
                a("div", ai, [
                  G(A(`Redeem ${d(n).exchangePoint} CozyCoins for ${d(n).productName}`) + " ", 1),
                  W((v(), g("button", {
                    class: "form-button btn loading-btn",
                    onClick: m
                  }, [
                    f.value ? (v(), g("i", ii)) : Y("", !0),
                    i[5] || (i[5] = G(" Redeem ", -1))
                  ])), [
                    [c, {
                      type: d(n).productTyp,
                      code: d(n).productCode,
                      item: d(n).productName,
                      usedPoints: d(n).exchangePoint
                    }, "exchange:detail"]
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), li = /* @__PURE__ */ ee(ri, [["__scopeId", "data-v-498645d0"]]), ci = { class: "task-detail redeem-list" }, ui = { class: "header" }, di = { class: "ctx" }, fi = { class: "redeem-item" }, pi = { class: "info" }, mi = { class: "title" }, vi = { class: "date" }, hi = { class: "form-item number" }, gi = ["value"], _i = ["disabled"], yi = {
  key: 0,
  class: "icon lutefont icon-loading"
}, bi = /* @__PURE__ */ Object.assign({
  name: "Email"
}, {
  __name: "Email",
  setup(e) {
    const t = ue(), n = ie(), { userinfo: s } = J(n), { pageData: o } = J(t), { send: l, loading: u } = Xe((m) => ia(m), { immediate: !1 });
    async function f() {
      if (o.value.completionStatus !== 1) {
        if (!s.value.email) {
          ae({
            message: "Email not found",
            icon: "icon-error"
          });
          return;
        }
        l({ email: s.value.email }).then(() => {
          ae("Subscription successful"), n.updateUserinfo(), Zn("update:task:list"), t.back();
        }).catch(() => {
          ae("Subscription failed");
        });
      }
    }
    return (m, r) => {
      const i = ve("track");
      return v(), g("div", ci, [
        a("div", ui, [
          a("i", {
            class: "lutefont icon-arrow-left",
            onClick: r[0] || (r[0] = (c) => d(t).back())
          }),
          r[2] || (r[2] = a("h2", null, "Earn CozyCoins", -1)),
          a("i", {
            class: "lutefont icon-close",
            onClick: r[1] || (r[1] = (...c) => d(t).toggle && d(t).toggle(...c))
          })
        ]),
        a("div", di, [
          Z(d(ke), {
            "wrapper-class": "list-wrapper",
            "auto-hide": !1,
            "auto-expand": !1
          }, {
            default: ce(() => {
              var c, h;
              return [
                a("div", fi, [
                  r[3] || (r[3] = a("div", { class: "icon" }, [
                    a("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  a("div", pi, [
                    a("div", mi, A(d(o).title), 1),
                    a("div", vi, A(d(o).pointsDesc), 1)
                  ])
                ]),
                r[6] || (r[6] = a("div", { class: "line-wrapper" }, [
                  a("div", { class: "line" })
                ], -1)),
                a("form", {
                  class: "redeem-form",
                  action: "#",
                  onSubmit: at(f, ["prevent"])
                }, [
                  r[5] || (r[5] = a("h4", null, "Complete email subscription", -1)),
                  a("div", hi, [
                    a("input", {
                      readonly: "",
                      value: (c = d(s)) == null ? void 0 : c.email,
                      class: "form-item__input",
                      type: "email",
                      placeholder: "Enter your Email"
                    }, null, 8, gi)
                  ]),
                  W((v(), g("button", {
                    type: "submit",
                    class: _e(["form-button btn loading-btn", { loading: d(u), completed: d(o).completionStatus === 1 }]),
                    disabled: d(o).completionStatus === 1
                  }, [
                    d(u) ? (v(), g("i", yi)) : Y("", !0),
                    r[4] || (r[4] = G(" Subscription ", -1))
                  ], 10, _i)), [
                    [i, { type: d(o).type, item: d(o).title, email: (h = d(s)) == null ? void 0 : h.email }, "task:detail"]
                  ])
                ], 32)
              ];
            }),
            _: 1,
            __: [6]
          })
        ])
      ]);
    };
  }
}), wi = { class: "redeem-list" }, Ci = { class: "header" }, xi = { class: "ctx" }, $i = { class: "list" }, Si = ["onClick"], ki = { class: "faq-title" }, Ei = { class: "faq-content-wrapper" }, Ti = ["innerHTML"], Pi = /* @__PURE__ */ Object.assign({
  name: "Faq"
}, {
  __name: "Faq",
  setup(e) {
    const t = ue(), n = Q([
      {
        active: !1,
        title: "What is the Momcozy Membership Program?",
        content: "The Momcozy Membership Program is a tiered rewards system. The more you engage, the more exclusive benefits you unlock."
      },
      {
        active: !1,
        title: "How do I join the membership program?",
        content: "If you already have an account on momcozy.com and have completed email activation, you are already participating in the program. Simply log in to your account!<br/>If you don't have an account, you just need to register for an momcozy account and complete the email activation steps so you can start earning rewards."
      },
      {
        active: !1,
        title: "What are the membership tiers?",
        content: `<p>There are four tiers:</p><p>Newbie (Create an account)</p><p>Explorer (First Order)</p><p>Enthusiant (spend $300 more)</p><p>Elite (spend $500 more)</p><p><a target="_blank" href="${Ne}/memberShip">Learn More</a></p>`
      },
      {
        active: !1,
        title: "How do I upgrade my membership tier?",
        content: "Your tier is automatically calculated based on your total spending within the calendar year. Upgrades happen within 24 hours after meeting the threshold."
      },
      {
        active: !1,
        title: "How long does my tier last?",
        content: "Your tier is valid for the current calendar year (Jan 1 – Dec 31). It will be re-evaluated annually based on your total spend."
      },
      {
        active: !1,
        title: "What happened to my Momcozy Points?",
        content: "Your Momcozy Points have been upgraded to CozyCoins.You can now use CozyCoins to redeem eligible products or discounts."
      },
      {
        active: !1,
        title: "What are CozyCoins?",
        content: "CozyCoins are the exclusive reward points within the Momcozy Membership Program. You can earn CozyCoins through shopping, daily check-ins, community interactions, and more. Use them to redeem discount coupons, exclusive gifts, or join members-only events."
      },
      {
        active: !1,
        title: "Where can I see my CozyCoins?",
        content: "My Account > CozyCoins to view your current balance and history"
      },
      {
        active: !1,
        title: "What can I redeem my CozyCoins for?",
        content: "CozyCoins can be redeemed for:discount coupons , gift cards, etc."
      },
      {
        active: !1,
        title: "Is there a limit to how many points I can redeem at once when I convert my CozyCoins ?",
        content: "Yes. You can redeem up to $30 worth of coupons per transaction."
      },
      {
        active: !1,
        title: "Do CozyCoins expire?",
        content: "Yes, points are valid for 180 days from the date they’re earned and will expire if unused."
      }
    ]);
    return (s, o) => (v(), g("div", wi, [
      a("div", Ci, [
        a("i", {
          class: "lutefont icon-arrow-left",
          onClick: o[0] || (o[0] = (l) => d(t).back())
        }),
        o[2] || (o[2] = a("h2", null, "FAQ", -1)),
        a("i", {
          class: "lutefont icon-close",
          onClick: o[1] || (o[1] = (...l) => d(t).toggle && d(t).toggle(...l))
        })
      ]),
      a("div", xi, [
        Z(d(ke), {
          "wrapper-class": "list-wrapper",
          "auto-hide": !1,
          "auto-expand": !1
        }, {
          default: ce(() => [
            a("ul", $i, [
              (v(!0), g(oe, null, Fe(n.value, (l, u) => (v(), g(oe, { key: u }, [
                a("li", {
                  class: _e({ active: l.active }),
                  onClick: (f) => l.active = !l.active
                }, [
                  a("div", ki, [
                    a("p", null, A(l.title), 1),
                    (v(), g("svg", {
                      class: _e(["icon", { active: l.active }]),
                      viewBox: "0 0 200 200",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, o[3] || (o[3] = [
                      a("line", {
                        class: "icon-line h-line",
                        x1: "50",
                        y1: "100",
                        x2: "150",
                        y2: "100"
                      }, null, -1),
                      a("line", {
                        class: "icon-line v-line",
                        x1: "100",
                        y1: "50",
                        x2: "100",
                        y2: "150"
                      }, null, -1)
                    ]), 2))
                  ]),
                  a("div", Ei, [
                    a("div", {
                      class: "faq-content",
                      innerHTML: l.content
                    }, null, 8, Ti)
                  ])
                ], 10, Si),
                o[4] || (o[4] = a("li", { class: "line full-line" }, null, -1))
              ], 64))), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]));
  }
}), Ri = /* @__PURE__ */ ee(Pi, [["__scopeId", "data-v-a1d6e706"]]);
function eo(e = () => null) {
  const t = Q(null);
  function n(s) {
    const { scrollTop: o, scrollHeight: l, clientHeight: u } = s.target;
    o + u + 20 >= l && e();
  }
  return Re(() => {
    t.value.scrollEl.addEventListener("scroll", n);
  }), Ye(() => {
    var o;
    const s = (o = t.value) == null ? void 0 : o.scrollEl;
    s && s.removeEventListener("scroll", n);
  }), {
    scrollRef: t,
    handleScroll: n
  };
}
function Li() {
  const e = Q(""), t = ue(), n = ie();
  window.addEventListener("visibilitychange", () => {
    document.visibilityState === "visible" && (e.value = Qt());
  }), be(e, () => {
    n.updateUserinfo();
  }), document.addEventListener("LUTE:AUTH:EXPIRED", () => {
    qs(), n.clearUserinfo(), t.clearComp(), ae({
      message: "Login expired !",
      icon: "icon-error",
      duration: 3e3
    });
  });
}
const Ii = { class: "redeem-list" }, Mi = { class: "header" }, zi = { class: "ctx" }, Di = { class: "balance" }, Ni = { class: "list" }, Oi = { class: "redeem-item" }, Ui = { class: "info" }, Ai = { class: "title" }, Fi = { class: "date" }, Vi = { class: "count" }, ji = {
  key: 1,
  class: "loading"
}, Hi = /* @__PURE__ */ Object.assign({
  name: "History"
}, {
  __name: "History",
  setup(e) {
    const t = ue(), n = ie(), { userinfo: s } = J(n), { loading: o, data: l, page: u, total: f, isLastPage: m, reload: r } = qn((h, p) => Js({ pageNum: h, pageSize: p }), {
      initialData: { userPointDetailList: [] },
      initialPage: 1,
      // 初始页码，默认为1
      initialPageSize: 10,
      data: (h) => h.userPointDetailList || [],
      append: !0
    });
    function i() {
      m.value || u.value++;
    }
    const { scrollRef: c } = eo(i);
    return po(r), (h, p) => {
      var x;
      return v(), g("div", Ii, [
        a("div", Mi, [
          a("i", {
            class: "lutefont icon-arrow-left",
            onClick: p[0] || (p[0] = (...T) => d(t).back && d(t).back(...T))
          }),
          p[2] || (p[2] = a("h2", null, "History", -1)),
          a("i", {
            class: "lutefont icon-close",
            onClick: p[1] || (p[1] = (...T) => d(t).toggle && d(t).toggle(...T))
          })
        ]),
        a("div", zi, [
          a("div", Di, [
            p[3] || (p[3] = G(" My CozyCoins: ", -1)),
            a("strong", null, A((x = d(s)) == null ? void 0 : x.points), 1)
          ]),
          Z(d(ke), {
            ref_key: "scrollRef",
            ref: c,
            "wrapper-class": "list-wrapper"
          }, {
            default: ce(() => [
              d(o) && !d(f) ? (v(), le(Ct, { key: 0 })) : Y("", !0),
              a("ul", Ni, [
                (v(!0), g(oe, null, Fe(d(l), (T) => (v(), g(oe, {
                  key: T.detailCode
                }, [
                  a("li", Oi, [
                    a("div", Ui, [
                      a("div", Ai, A(T.remark), 1),
                      a("div", Fi, A(T.expiredTime ? d(bo)(T.expiredTime).format("YYYY-MM-DD HH:mm:ss") : ""), 1)
                    ]),
                    a("div", Vi, A(T.point > 0 ? `+${T.point}` : T.point), 1)
                  ]),
                  p[4] || (p[4] = a("li", { class: "line" }, null, -1))
                ], 64))), 128))
              ]),
              d(o) && d(f) > 0 ? (v(), g("div", ji, p[5] || (p[5] = [
                a("i", { class: "icon big lutefont icon-loading" }, null, -1)
              ]))) : Y("", !0)
            ]),
            _: 1
          }, 512)
        ])
      ]);
    };
  }
}), Wi = /* @__PURE__ */ ee(Hi, [["__scopeId", "data-v-e12d5d04"]]), qi = { class: "guest" }, Yi = ["href"], Bi = {
  __name: "GuestLogin",
  setup(e) {
    return (t, n) => {
      const s = ve("track");
      return v(), g("div", qi, [
        n[1] || (n[1] = a("p", { class: "tips" }, [
          G(" Your CozyCoins perks are waiting"),
          a("br"),
          G(" Log in to get started. ")
        ], -1)),
        W((v(), g("a", { href: d(Xt) }, n[0] || (n[0] = [
          a("button", null, "Log In", -1)
        ]), 8, Yi)), [
          [s, { from: "index" }, "login"]
        ])
      ]);
    };
  }
}, Ki = /* @__PURE__ */ ee(Bi, [["__scopeId", "data-v-cf7b71e0"]]), Gi = {}, Qi = { class: "tag" };
function Xi(e, t) {
  return v(), g("div", Qi, [
    Tn(e.$slots, "default", {}, void 0, !0)
  ]);
}
const to = /* @__PURE__ */ ee(Gi, [["render", Xi], ["__scopeId", "data-v-fadcf8ac"]]), Ji = { class: "prizes" }, Zi = { class: "icons" }, er = {
  __name: "Prizes",
  setup(e) {
    const t = ue();
    function n() {
      window.open(Ne, "_blank");
    }
    return (s, o) => {
      const l = ve("track");
      return v(), g("ul", Ji, [
        W((v(), g("li", {
          onClick: o[0] || (o[0] = (u) => d(t).setComp("coins"))
        }, o[2] || (o[2] = [
          a("i", { class: "lutefont icon-points" }, null, -1),
          a("span", { class: "ctx" }, "Earn CozyCoins", -1),
          a("i", { class: "lutefont icon-arrow" }, null, -1)
        ]))), [
          [l, { item: "coins" }, "menu"]
        ]),
        W((v(), g("li", {
          onClick: o[1] || (o[1] = (u) => d(t).setComp("rewards"))
        }, [
          o[5] || (o[5] = a("i", { class: "lutefont icon-gift" }, null, -1)),
          o[6] || (o[6] = a("span", { class: "ctx" }, "Redeem Rewards", -1)),
          a("div", Zi, [
            Z(to, null, {
              default: ce(() => o[3] || (o[3] = [
                G("New", -1)
              ])),
              _: 1,
              __: [3]
            }),
            o[4] || (o[4] = a("i", { class: "lutefont icon-arrow" }, null, -1))
          ])
        ])), [
          [l, { item: "rewards" }, "menu"]
        ]),
        W((v(), g("li", { onClick: n }, o[7] || (o[7] = [
          a("i", { class: "lutefont icon-gift" }, null, -1),
          a("span", { class: "ctx" }, "View More Benefits", -1),
          a("i", { class: "lutefont icon-arrow" }, null, -1)
        ]))), [
          [l, { item: "more" }, "menu"]
        ])
      ]);
    };
  }
}, tr = /* @__PURE__ */ ee(er, [["__scopeId", "data-v-b623f3c9"]]), nr = { class: "userinfo" }, or = { class: "avatar" }, sr = ["src"], ar = {
  key: 1,
  class: "img",
  src: "https://cdn.shopify.com/s/files/1/0559/2321/2486/files/avatar_fbb6ef1f-f3f3-40bb-9d27-207a2c9c7c6f.svg?v=1756462416",
  alt: ""
}, ir = { class: "level" }, rr = { class: "name" }, lr = { class: "email" }, cr = {
  __name: "UserInfo",
  setup(e) {
    const t = ue(), n = ie(), { userinfo: s } = J(n);
    return (o, l) => {
      var u, f, m, r;
      return v(), g("div", nr, [
        a("div", or, [
          d(s).avatar ? (v(), g("img", {
            key: 0,
            class: "img",
            src: d(s).avatar,
            alt: ""
          }, null, 8, sr)) : (v(), g("img", ar)),
          a("div", ir, A(`Lv.${d(s).memberLevel}`), 1)
        ]),
        a("div", rr, A((u = d(s)) != null && u.firstName || (f = d(s)) != null && f.lastName ? `${d(s).firstName} ${d(s).lastName}` : "Mom"), 1),
        a("div", lr, A((m = d(s)) == null ? void 0 : m.email), 1),
        a("div", {
          class: "coins",
          onClick: l[0] || (l[0] = (i) => d(t).setComp("history"))
        }, [
          a("span", null, [
            l[1] || (l[1] = G("CozyCoins: ", -1)),
            a("strong", null, A((r = d(s)) == null ? void 0 : r.points), 1)
          ]),
          l[2] || (l[2] = a("i", { class: "lutefont icon-history" }, null, -1))
        ])
      ]);
    };
  }
}, ur = /* @__PURE__ */ ee(cr, [["__scopeId", "data-v-95a75a9e"]]), dr = { class: "box" }, fr = { class: "info" }, pr = /* @__PURE__ */ Object.assign({
  name: "Index"
}, {
  __name: "index",
  setup(e) {
    const t = ue(), n = ie();
    return (s, o) => (v(), g("div", dr, [
      a("i", {
        class: "opreate lutefont icon-question",
        onClick: o[0] || (o[0] = (l) => d(t).setComp("faq"))
      }),
      a("i", {
        class: "opreate lutefont icon-close",
        onClick: o[1] || (o[1] = (...l) => d(t).toggle && d(t).toggle(...l))
      }),
      o[3] || (o[3] = a("div", { class: "title" }, [
        a("h2", null, "Welcome to"),
        a("p", null, "Member Center")
      ], -1)),
      a("div", fr, [
        d(n).userinfo ? (v(), le(ur, {
          key: 1,
          class: "user"
        })) : (v(), le(Ki, { key: 0 })),
        o[2] || (o[2] = a("div", { class: "line" }, null, -1)),
        Z(tr)
      ])
    ]));
  }
}), mr = /* @__PURE__ */ ee(pr, [["__scopeId", "data-v-ef5c6174"]]), vr = { class: "progress-container" }, hr = {
  __name: "Progress",
  props: {
    value: {
      type: Number,
      default: 0,
      validator: (e) => e >= 0 && e <= 100
    }
  },
  setup(e) {
    const t = e, n = Q(0);
    return be(() => t.value, (s) => {
      n.value = s;
    }, { immediate: !0 }), (s, o) => (v(), g("div", vr, [
      a("div", {
        class: "progress-bar",
        style: qe({ width: `${n.value}%` })
      }, null, 4)
    ]));
  }
}, gr = /* @__PURE__ */ ee(hr, [["__scopeId", "data-v-7178016c"]]), _r = {
  key: 1,
  class: "list"
}, yr = { class: "redeem-item" }, br = { class: "info" }, wr = { class: "title" }, Cr = { class: "product-name" }, xr = { class: "date" }, $r = {
  key: 0,
  class: "progress-wrapper"
}, Sr = { class: "operate" }, kr = ["onClick"], Er = {
  key: 0,
  class: "icon lutefont icon-loading"
}, Tr = {
  __name: "Redeem",
  setup(e) {
    const t = ue(), n = ie(), { userinfo: s } = J(n), o = ge(() => s.value ? na : oa), { loading: l, data: u } = Xe(
      () => o.value({
        page: 1,
        pageSize: 100,
        productType: [3, 4, 5, 6, 7]
      }),
      { initialData: [] }
    );
    async function f(m) {
      if (m.productType === 5) {
        t.setComp("covertCoins", m);
        return;
      }
      t.setComp("covertDiscount", m);
    }
    return (m, r) => {
      const i = ve("track");
      return v(), le(d(ke), { "wrapper-class": "list-wrapper" }, {
        default: ce(() => [
          d(l) ? (v(), le(Ct, { key: 0 })) : (v(), g("ul", _r, [
            (v(!0), g(oe, null, Fe(d(u), (c) => {
              var h, p, x, T;
              return v(), g(oe, {
                key: c.productCode
              }, [
                W((v(), g("li", yr, [
                  r[2] || (r[2] = a("div", { class: "icon" }, [
                    a("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  a("div", br, [
                    a("div", wr, [
                      a("div", Cr, A(c.productType === 5 ? "Convert your CozyCoins" : c.productName), 1),
                      c.productCode === "PP019001" ? (v(), le(to, { key: 0 }, {
                        default: ce(() => r[0] || (r[0] = [
                          G(" only for 7.7-7.9 ", -1)
                        ])),
                        _: 1,
                        __: [0]
                      })) : Y("", !0)
                    ]),
                    a("div", xr, A(c.productType === 5 ? "100 CozyCoins=$1" : `${c.exchangePoint} CozyCoins`), 1),
                    c.exchangePoint > ((h = d(s)) == null ? void 0 : h.points) ? (v(), g("div", $r, [
                      Z(gr, {
                        value: Math.floor(((p = d(s)) == null ? void 0 : p.points) / c.exchangePoint * 100)
                      }, null, 8, ["value"])
                    ])) : Y("", !0)
                  ]),
                  a("div", Sr, [
                    c.exchangePoint <= ((x = d(s)) == null ? void 0 : x.points) ? (v(), g("button", {
                      key: 0,
                      class: "btn loading-btn loading",
                      onClick: (M) => f(c)
                    }, [
                      c.loading ? (v(), g("i", Er)) : Y("", !0),
                      r[1] || (r[1] = G(" Redeem ", -1))
                    ], 8, kr)) : Y("", !0)
                  ])
                ])), [
                  [i, {
                    type: c.productTyp,
                    code: c.productCode,
                    item: c.productName,
                    canExchange: c.exchangePoint <= ((T = d(s)) == null ? void 0 : T.points)
                  }, "exchange"]
                ]),
                r[3] || (r[3] = a("li", { class: "line" }, null, -1))
              ], 64);
            }), 128))
          ]))
        ]),
        _: 1
      });
    };
  }
}, Pr = {
  key: 1,
  class: "list"
}, Rr = { class: "redeem-item" }, Lr = { class: "info" }, Ir = { class: "title" }, Mr = ["onClick"], zr = { class: "operate" }, Dr = ["onClick"], Nr = {
  key: 2,
  class: "list"
}, Or = {
  key: 3,
  class: "loading"
}, Ur = {
  key: 1,
  class: "list"
}, Ar = {
  __name: "Rewards",
  setup(e) {
    const t = ie(), { userinfo: n } = J(t), { loading: s, data: o, page: l, total: u, isLastPage: f } = qn(
      (p, x) => sa({ pageNum: p, pageSize: x }),
      {
        initialData: { exchangeProductList: [] },
        initialPage: 1,
        // 初始页码，默认为1
        initialPageSize: 10,
        data: (p) => p.exchangeProductList || [],
        append: !0,
        immediate: !!n.value
      }
    );
    function m() {
      f.value || l.value++;
    }
    const { scrollRef: r } = eo(m);
    function i(p) {
      return !p || p === "no discount code available" ? "" : p;
    }
    async function c(p) {
      if (p.productType === 7) {
        const x = await aa(p.ticketCode);
        window.open(x);
      } else
        window.open(`/discount/${p.ticketCode}`);
    }
    function h(p) {
      p && navigator.clipboard.writeText(p).then(() => {
        ae("Copied to clipboard");
      }).catch((x) => {
        console.error("Failed to copy: ", x);
      });
    }
    return (p, x) => {
      const T = ve("track"), M = ve("visible-track");
      return W((v(), le(d(ke), {
        ref_key: "scrollRef",
        ref: r,
        "wrapper-class": "list-wrapper"
      }, {
        default: ce(() => [
          d(n) ? (v(), g(oe, { key: 0 }, [
            d(s) && !d(u) ? (v(), le(Ct, { key: 0 })) : Y("", !0),
            d(o).length ? (v(), g("ul", Pr, [
              (v(!0), g(oe, null, Fe(d(o), (E) => (v(), g(oe, {
                key: E.id
              }, [
                a("li", Rr, [
                  x[1] || (x[1] = a("div", { class: "icon" }, [
                    a("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  a("div", Lr, [
                    a("div", Ir, A(E.productName), 1),
                    W((v(), g("div", {
                      class: "date",
                      onClick: (F) => h(i(E.ticketCode))
                    }, [
                      G(A(i(E.ticketCode) || "-"), 1)
                    ], 8, Mr)), [
                      [T, {
                        type: E.productType,
                        code: E.ticketCode,
                        item: E.productName
                      }, "point:copy"]
                    ])
                  ]),
                  a("div", zr, [
                    i(E.ticketCode) ? W((v(), g("button", {
                      key: 0,
                      class: "btn",
                      onClick: (F) => c(E)
                    }, x[0] || (x[0] = [
                      G(" Use Coupon ", -1)
                    ]), 8, Dr)), [
                      [T, {
                        type: E.productType,
                        code: E.ticketCode,
                        item: E.productName
                      }, "point:jump"]
                    ]) : Y("", !0)
                  ])
                ]),
                x[2] || (x[2] = a("li", { class: "line" }, null, -1))
              ], 64))), 128))
            ])) : Y("", !0),
            !d(s) && !d(o).length ? (v(), g("div", Nr, x[3] || (x[3] = [
              a("p", null, "No rewards redeemed yet.", -1)
            ]))) : Y("", !0),
            d(s) && d(u) > 0 ? (v(), g("div", Or, x[4] || (x[4] = [
              a("i", { class: "icon big lutefont icon-loading" }, null, -1)
            ]))) : Y("", !0)
          ], 64)) : (v(), g("div", Ur, x[5] || (x[5] = [
            a("p", null, "Log in now to check your rewards.", -1)
          ])))
        ]),
        _: 1
      })), [
        [M, void 0, "visible:rewards"]
      ]);
    };
  }
}, Fr = /* @__PURE__ */ ee(Ar, [["__scopeId", "data-v-3f8b063d"]]), Vr = { class: "tabs-container" }, jr = { class: "tabs-header" }, Hr = ["onClick"], Wr = {
  __name: "Tabs",
  props: /* @__PURE__ */ Ut({
    tabs: {
      type: Array,
      required: !0
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ut(["tabChange"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, s = t, o = Pn(e, "modelValue");
    be(
      () => o.value,
      (r) => {
        const i = n.tabs.findIndex((c) => c.name === r);
        i !== -1 && m(i);
      }
    );
    function l(r, i) {
      o.value !== r.name && (o.value = r.name, s("tabChange", r.name), m(i));
    }
    const u = Q([]), f = Q({
      width: "0px",
      left: "0px"
    });
    function m(r) {
      if (u.value && u.value.length > 0) {
        const i = u.value[r];
        i && (f.value = {
          width: `${i.offsetWidth}px`,
          left: `${i.offsetLeft}px`
        });
      }
    }
    return Re(() => {
      m(0);
    }), (r, i) => (v(), g("div", Vr, [
      a("div", jr, [
        (v(!0), g(oe, null, Fe(e.tabs, (c, h) => (v(), g("div", {
          key: c.name,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: u,
          class: _e(["tab", { active: o.value === c.name }]),
          onClick: (p) => l(c, h)
        }, A(c.label), 11, Hr))), 128)),
        a("div", {
          class: "slider",
          style: qe(f.value)
        }, null, 4)
      ])
    ]));
  }
}, qr = /* @__PURE__ */ ee(Wr, [["__scopeId", "data-v-3c401f9f"]]), Yr = { class: "redeem-list" }, Br = { class: "header" }, Kr = { class: "ctx" }, Gr = ["href"], Qr = {
  key: 1,
  class: "balance"
}, Xr = /* @__PURE__ */ Object.assign({
  name: "Rewards"
}, {
  __name: "index",
  setup(e) {
    const t = ie(), { userinfo: n } = J(t), s = ue(), { pageData: o } = J(s), l = Q("redeem");
    be(
      () => o.value.type,
      (f) => {
        l.value = f || "redeem";
      }
    );
    const u = [
      {
        label: "Redeem",
        name: "redeem"
      },
      {
        label: "Your Rewards",
        name: "rewards"
      }
    ];
    return (f, m) => {
      var i;
      const r = ve("track");
      return v(), g("div", Yr, [
        a("div", Br, [
          a("i", {
            class: "lutefont icon-arrow-left",
            onClick: m[0] || (m[0] = (c) => d(s).back())
          }),
          m[3] || (m[3] = a("h2", null, "Redeem Rewards", -1)),
          a("i", {
            class: "lutefont icon-close",
            onClick: m[1] || (m[1] = (...c) => d(s).toggle && d(s).toggle(...c))
          })
        ]),
        a("div", Kr, [
          d(n) ? (v(), g("div", Qr, [
            m[5] || (m[5] = G(" My CozyCoins: ", -1)),
            a("strong", null, A((i = d(n)) == null ? void 0 : i.points), 1)
          ])) : W((v(), g("a", {
            key: 0,
            href: d(Xt),
            class: "balance link"
          }, m[4] || (m[4] = [
            a("strong", null, "Log In >", -1)
          ]), 8, Gr)), [
            [r, { from: "rewards" }, "login"]
          ]),
          Z(qr, {
            modelValue: l.value,
            "onUpdate:modelValue": m[2] || (m[2] = (c) => l.value = c),
            class: "tabs",
            tabs: u
          }, null, 8, ["modelValue"]),
          l.value === "redeem" ? (v(), le(Tr, { key: 2 })) : Y("", !0),
          l.value === "rewards" ? (v(), le(Fr, { key: 3 })) : Y("", !0)
        ])
      ]);
    };
  }
}), Jr = /* @__PURE__ */ ee(Xr, [["__scopeId", "data-v-e41c06f0"]]), Zr = { class: "task-detail redeem-list" }, el = { class: "header" }, tl = { class: "ctx" }, nl = { class: "redeem-item" }, ol = { class: "info" }, sl = { class: "title" }, al = { class: "date" }, il = { class: "form-item number" }, rl = ["value"], ll = ["disabled"], cl = {
  key: 0,
  class: "icon lutefont icon-loading"
}, ul = /* @__PURE__ */ Object.assign({
  name: "Sms"
}, {
  __name: "Sms",
  setup(e) {
    const t = ue(), n = ie(), { userinfo: s } = J(n), { pageData: o } = J(t), { send: l, loading: u } = Xe((m) => ra(m), { immediate: !1 });
    async function f() {
      if (o.value.completionStatus !== 1) {
        if (!s.value.phone) {
          ae({
            message: "Phone not found",
            icon: "icon-error"
          });
          return;
        }
        l({ phone: s.value.phone }).then(() => {
          ae("Subscription successful"), n.updateUserinfo(), Zn("update:task:list"), t.back();
        }).catch(() => {
          ae("Subscription failed");
        });
      }
    }
    return (m, r) => {
      const i = ve("track");
      return v(), g("div", Zr, [
        a("div", el, [
          a("i", {
            class: "lutefont icon-arrow-left",
            onClick: r[0] || (r[0] = (c) => d(t).back())
          }),
          r[2] || (r[2] = a("h2", null, "Earn CozyCoins", -1)),
          a("i", {
            class: "lutefont icon-close",
            onClick: r[1] || (r[1] = (...c) => d(t).toggle && d(t).toggle(...c))
          })
        ]),
        a("div", tl, [
          Z(d(ke), { "wrapper-class": "list-wrapper" }, {
            default: ce(() => {
              var c, h;
              return [
                a("div", nl, [
                  r[3] || (r[3] = a("div", { class: "icon" }, [
                    a("i", { class: "lutefont icon-gift" })
                  ], -1)),
                  a("div", ol, [
                    a("div", sl, A(d(o).title), 1),
                    a("div", al, A(d(o).pointsDesc), 1)
                  ])
                ]),
                r[6] || (r[6] = a("div", { class: "line-wrapper" }, [
                  a("div", { class: "line" })
                ], -1)),
                a("form", {
                  class: "redeem-form",
                  action: "#",
                  onSubmit: at(f, ["prevent"])
                }, [
                  r[5] || (r[5] = a("h4", null, "Enter your mobile number to subscribe !", -1)),
                  a("div", il, [
                    a("input", {
                      readonly: "",
                      value: (c = d(s)) == null ? void 0 : c.phone,
                      class: "form-item__input",
                      type: "text",
                      placeholder: "Enter your mobile number"
                    }, null, 8, rl)
                  ]),
                  W((v(), g("button", {
                    type: "submit",
                    disabled: d(o).completionStatus === 1,
                    class: _e(["form-button btn loading-btn", { loading: d(u), completed: d(o).completionStatus === 1 }])
                  }, [
                    d(u) ? (v(), g("i", cl)) : Y("", !0),
                    r[4] || (r[4] = G(" Subscription ", -1))
                  ], 10, ll)), [
                    [i, { type: d(o).type, item: d(o).title, phone: (h = d(s)) == null ? void 0 : h.phone }, "task:detail"]
                  ])
                ], 32)
              ];
            }),
            _: 1,
            __: [6]
          })
        ])
      ]);
    };
  }
}), Sn = {
  index: mr,
  history: Wi,
  coins: Ma,
  sms: ul,
  rewards: Jr,
  covertDiscount: li,
  covertCoins: Ga,
  faq: Ri,
  email: bi
}, ue = kn("component", () => {
  const e = Q(!1), t = ["index"], n = Q("fade"), s = Q("index"), o = Q({}), l = ge(() => Sn[s.value]);
  function u(i, c = {}) {
    n.value = "fade", t.push(i), s.value = i, o.value = c;
  }
  function f(i = {}) {
    n.value = "back", t.pop(), s.value = t[t.length - 1] || "index", o.value = i;
  }
  function m() {
    e.value = !e.value, n.value = e.value ? "fade" : "back";
  }
  function r() {
    n.value = "fade", t.length = 0, t.push("index"), s.value = "index", o.value = {};
  }
  return { comp: s, setComp: u, currentComp: l, components: Sn, back: f, animateType: n, pageVisible: e, toggle: m, pageData: o, clearComp: r };
}), ie = kn("userinfo", () => {
  const e = Q(null);
  async function t() {
    if (!Qt())
      return;
    const s = await Xs();
    e.value = s;
  }
  function n() {
    e.value = null;
  }
  return Re(t), {
    userinfo: e,
    updateUserinfo: t,
    clearUserinfo: n
  };
}), dl = {
  id: "lute-redeem-app",
  class: "lute-redeem-app"
}, fl = { id: "lute-redeem-app-page" }, pl = { class: "btn-wrapper" }, ml = { class: "btn-container" }, vl = {
  key: 0,
  class: "btn-label"
}, hl = {
  key: 1,
  class: "close-btn"
}, gl = {
  __name: "App",
  setup(e) {
    const t = ue(), n = Q(null), s = Q();
    function o() {
      fn(() => {
        s.value = n.value.children[0].offsetWidth;
      });
    }
    be(() => t.pageVisible, () => {
      o(), t.pageVisible ? document.documentElement.classList.add("is-scrollBlock") : document.documentElement.classList.remove("is-scrollBlock");
    });
    function l() {
      const u = new URLSearchParams(window.location.search);
      u.get("lt-redeem") && (u.delete("lt-redeem"), history.replaceState({}, "", `${window.location.pathname}${u.toString() ? `?${u.toString()}` : ""}`), fn(() => {
        t.toggle();
      }));
    }
    return Re(() => {
      l();
    }), ie(), Li(), (u, f) => {
      const m = ve("visible-track"), r = ve("track");
      return v(), g("div", dl, [
        a("div", fl, [
          Z(Ot, { name: "page" }, {
            default: ce(() => [
              d(t).pageVisible ? W((v(), g("div", {
                key: 0,
                class: "box-wrapper",
                role: "dialog",
                onTouchmovePassive: f[0] || (f[0] = at(() => {
                }, ["stop"]))
              }, [
                Z(Ot, {
                  name: d(t).animateType
                }, {
                  default: ce(() => [
                    (v(), le(mo, null, [
                      (v(), le(vo(d(t).currentComp), { class: "box" }))
                    ], 1024))
                  ]),
                  _: 1
                }, 8, ["name"])
              ], 32)), [
                [m, void 0, "visible:app"]
              ]) : Y("", !0)
            ]),
            _: 1
          })
        ]),
        a("div", pl, [
          a("div", ml, [
            W((v(), g("button", {
              ref_key: "btnRef",
              ref: n,
              class: "btn",
              style: qe(`--btn-width: ${s.value}px`),
              onClick: f[1] || (f[1] = (...i) => d(t).toggle && d(t).toggle(...i))
            }, [
              d(t).pageVisible ? (v(), g("div", hl, f[3] || (f[3] = [
                a("i", { class: "lutefont icon-close" }, null, -1)
              ]))) : (v(), g("div", vl, f[2] || (f[2] = [
                a("i", { class: "lutefont icon-gift" }, null, -1),
                G(" Rewards ", -1)
              ])))
            ], 4)), [
              [r, { type: !d(t).pageVisible }, "click:redeem-btn"]
            ])
          ])
        ])
      ]);
    };
  }
}, _l = /* @__PURE__ */ ee(gl, [["__scopeId", "data-v-507cc179"]]), yl = {
  mounted(e, t) {
    if (!window.ltTrack)
      return;
    const n = t.arg || "track_event", s = t.value || {}, o = ie(), { userinfo: l } = J(o);
    e.__trackHandler__ = () => {
      var u, f;
      window.ltTrack(`redeem:${n}`, {
        ...s,
        userinfo: l.value ? {
          id: (u = l.value) == null ? void 0 : u.uid,
          email: (f = l.value) == null ? void 0 : f.email
        } : null
      });
    }, e.addEventListener("click", e.__trackHandler__);
  },
  unmounted(e) {
    window.ltTrack && (e.removeEventListener("click", e.__trackHandler__), delete e.__trackHandler__);
  }
}, bl = {
  mounted(e, t) {
    if (!window.ltTrack)
      return;
    const n = t.arg || "visible_event", s = t.value || {}, o = ie(), { userinfo: l } = J(o), u = new IntersectionObserver((f) => {
      f.forEach((m) => {
        var r, i;
        m.isIntersecting && (window.ltTrack(`redeem:${n}`, {
          ...s,
          userinfo: l.value ? {
            id: (r = l.value) == null ? void 0 : r.uid,
            email: (i = l.value) == null ? void 0 : i.email
          } : null
        }), u.disconnect());
      });
    });
    u.observe(e), e.__vVisibleTrackObserver__ = u;
  },
  unmounted(e) {
    window.ltTrack && e.__vVisibleTrackObserver__ && (e.__vVisibleTrackObserver__.disconnect(), delete e.__vVisibleTrackObserver__);
  }
}, wl = ho(_l, {
  configureApp(e) {
    e.use(so()), e.directive("track", yl), e.directive("visible-track", bl);
  },
  shadowRoot: !1
});
customElements.define("lute-redeem", wl);
